import numeral from 'numeral';

import { buildUIStringArray } from '../../utils/index';

import { getItemByNid } from '../../utils/calculations-helper';

import { PDF_CREATE, pdfCreated } from '../../modules/app';

import { CALCULATION_TYPE_PLANE, CALCULATION_TYPE_PIPE, CALCULATION_TYPE_DUCT, CALCULATION_TYPE_CIRCULAR_DUCT, CALCULATION_TYPE_RECTANGULAR_DUCT, CALCULATION_TYPE_VERTICAL_TANK, CALCULATION_TYPE_HORIZONTAL_TANK, CALCULATION_TYPE_RECTANGULAR_TANK } from '../../modules/calculation';

// pdfmake cannot be bundled with this project's older webpack/babel toolchain.
// We load it via <script> tags in the HTML template and then read it from `window`.
function ensurePdfMake() {
  // pdfmake's script tag usually exposes a `pdfMake` global, but we keep a fallback.
  if (typeof window === 'undefined') {
    throw new Error('pdfMake is not loaded: running outside of browser.');
  }
  if (window.pdfMake && typeof window.pdfMake.createPdf === 'function') {
    return window.pdfMake;
  }
  if (typeof window.createPdf === 'function') {
    return { createPdf: window.createPdf };
  }
  throw new Error('pdfMake is not loaded. Ensure `pdfmake.min.js` and `vfs_fonts.js` are loaded before generating a PDF.');
}

var lGreen = '#ebebeb';
var dGreen = '#dadada';
var parocRed = '#BD1823';


// var map = require('./kone_pdf_font.map.js');
// var data = require('./kone_pdf_font.js');

export function createMiddleware() {
  return store => next => action => {
    const { type, payload } = action;

    switch (type) {
      case PDF_CREATE:
        next(action);
        setTimeout(()=>{
          createPDF(store, payload);
        }, 1000);
        break;

        default:
        next(action);
    }
  };
}

function createPDF(store, payload) {
  const {
    project,
    translations,
    app,
    settings,
    adapters,
    databasedate,
  } = store.getState();

  const {
      printLanguage,
      printName,
      printNameValue,
      printDate,
      printDateValue,
      printTime,
      printTimeValue,
      printAll,
      printProjects,
      printCalculations,
    } = payload;
  const {
    calculations,
    calculationIndex,
    title,
    clientName,
    address,
    reference,
    useMarineProducts,
  } = project;

  let ui = buildUIStringArray(printLanguage, translations.data);

  let calculationsStartIndex = 0;
  let calculationsEndIndex = calculations.length;

  var calculationsPrintOut = [];
  const mechanicalFastenersInputs = [
    {name: ui['MECHANICAL_FASTENER_1'], id: '0.0007'},
    {name: ui['MECHANICAL_FASTENER_2'], id: '0.0005'},
  ];

  for(let i = calculationsStartIndex; i < calculationsEndIndex; i++) {
    let c = calculations[i];

    if(!printAll) {
      if( printCalculations.indexOf(c.name) == -1) {
        continue;
      }
    }

    let r = c.results;

    let calculationWarnings = [];
    let calculationWarningsIndicator = '';
    let calculationWarningsIndex = 0;

    let spacerInputs = [];


// ////////////////////////////////////////////////////////////////////////////////////////
// //////////
// ////////// PROJECT NAME
// //////////

    if(printProjects) {
      let projectPart = {items: [
        {title: ui['PROJECTS-CUSTOMER'], value: clientName},
        {title: ui['PROJECTS-ADDRESS'], value: address},
        {title: ui['PROJECTS-REFERENCE'], value: reference},
      ]};

      let projectTitle = createPartTitle(ui['PROJECTS-PROJECT_NAME'] + ': ' + title);

      let calcProjectPart = createTableTwoCols(projectPart);
      calculationsPrintOut.push(projectTitle, calcProjectPart);
    }


// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
/*

########  ##          ###    ##    ## ########
##     ## ##         ## ##   ###   ## ##
##     ## ##        ##   ##  ####  ## ##
########  ##       ##     ## ## ## ## ######
##        ##       ######### ##  #### ##
##        ##       ##     ## ##   ### ##
##        ######## ##     ## ##    ## ########

 */
    if (c.type == CALCULATION_TYPE_PLANE) {
      spacerInputs = [
        {name: ui['SPACER_1'], id: '0.0035'},
        {name: ui['SPACER_2'], id: '0.006'},
        {name: ui['SPACER_3'], id: '0.0085'},
      ];

      if(r.sectionResults[0].warnings && r.sectionResults[0].warnings.object.length > 0) {
        for(let w = 0; w < r.sectionResults[0].warnings.object.length; w++) {
          calculationWarnings.push(r.sectionResults[0].warnings.object[w]);
          calculationWarningsIndex++;
          calculationWarningsIndicator += calculationWarningsIndex + ') ';
        }
      }

      const material = ( (typeof r.sectionResults[0].material === 'string') ? r.sectionResults[0].material : ( (r.sectionResults[0].material[printLanguage] !== false) ? r.sectionResults[0].material[printLanguage] : r.sectionResults[0].material['English']) );
      let objectPart = {title: ui['PDF-TARGET'], items: [
          {title: ui['PDF-MATERIAL'], value: material, warnings: calculationWarningsIndicator},
          {title: ui['SETTINGS-THICKNESS'], value: (c.sections[0].thickness).toString() + ' mm'},
      ]
      };
      c.sections[0].shape === 'square' && objectPart.items.push({title: ui['GENERAL-HEIGHT'], value: (c.sections[0].height).toString() + ' m'});
      c.sections[0].shape === 'square' && objectPart.items.push({title: ui['GENERAL-WIDTH'], value: (c.sections[0].width).toString() + ' m'});
      c.sections[0].shape !== 'square' && objectPart.items.push({title: ui['GENERAL-OUTER_DIAMETER'], value: (c.sections[0].height).toString() + ' m'});
      objectPart.items.push({ title: ui['GENERAL_ORIENTATION'], value: (c.sections[0].direction === 'hor' ? ui['TARGET_HORIZONTAL'] : ui['TARGET_VERTICAL']) });
      objectPart.items.push({ title: ui['GENERAL_SHAPE'], value: (c.sections[0].shape === 'square' ? ui['TARGET_QUADRILATERAL'] : ui['TARGET_CIRCULAR']) });
      c.sections[0].direction === 'hor' && objectPart.items.push({ title: ui['GENERAL_LOCATION'], value: (c.sections[0].position === 'top' ? ui['TARGET_TOP_PART'] : ui['TARGET_BOTTOM_PART']) });

      let calcObjectPart = createTableTwoCols(objectPart);

      let insulations = [];
      if(c.sections[0].noInsulation) {
        insulations.push({title: ui['GENERAL-NO_INSULATION'], detail: '', value: ''});
      } else {
        for(let j = 0; j < r.sectionResults[0].layers.length; j++) {
          calculationWarningsIndicator = '';
          if(r.sectionResults[0].layers[j].warnings.length > 0) {
            for(let w = 0; w < r.sectionResults[0].layers[j].warnings.length; w++) {
              calculationWarnings.push(r.sectionResults[0].layers[j].warnings[w]);
              calculationWarningsIndex++;
              calculationWarningsIndicator += ' ' + calculationWarningsIndex + ')';
            }
          }
          insulations.push({
            title: r.sectionResults[0].layers[j].product.name,
            detail: (r.sectionResults[0].layers[j].product.thickness).toString() + ' mm',
            value: (numeral(r.sectionResults[0].layers[j].surfaceTemperature).format('0.0')).toString() + ' °C',
            warnings: calculationWarningsIndicator
          });
        }
      }
      let insulationPart = {
        title: ui['PDF-INSULATIONS'], items: insulations
      };
      let calcInsulationPart =  createTableThreeCols(insulationPart);

      let claddingPart = {};
      if(c.sections[0].noInsulation) {
        claddingPart = {title: ui['INSULATION-CLADDING'], items: [
          {title: ui['GENERAL-NO_CLADDING'], value: ''},
        ]};
      } else {
        calculationWarningsIndicator = '';
        if(r.sectionResults[0].warnings && r.sectionResults[0].warnings.surface.length > 0) {
          for(let w = 0; w < r.sectionResults[0].warnings.surface.length; w++) {
            calculationWarnings.push(r.sectionResults[0].warnings.surface[w]);
            calculationWarningsIndex++;
            calculationWarningsIndicator += calculationWarningsIndex + ') ';
          }
        }
        const cladding = ( (typeof r.sectionResults[0].cladding === 'string') ? r.sectionResults[0].cladding : ( (r.sectionResults[0].cladding[printLanguage] !== false) ? r.sectionResults[0].cladding[printLanguage] : r.sectionResults[0].cladding['English']) );
        claddingPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: cladding, value: ui['INSULATION-EMISSITIVITY'] + ': ' + (c.sections[0].emissivity).toString(), warnings: calculationWarningsIndicator},
        ]
        };
        if (c.sections[0].supportOfCladding) {
          const type = spacerInputs.find(item => item.id === c.sections[0].influenceOnHeatloss).name || 'not found';
          claddingPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}, ${(numeral(c.sections[0].spacersPerM).format('0')).toString()} / m²` });
        }

        if (c.sections[0].mechanicalFastener) {
          const type = mechanicalFastenersInputs.find(item => item.id === c.sections[0].mechanicalInfluence).name || 'not found';
          claddingPart.items.push({ title: ui['GENERAL_MECH_FASTENER'], value: `${type}, ${(numeral(c.sections[0].mechanicalPerM).format('0')).toString()} / m²` });
        }
      }
      let calcCladdingPart = createTableTwoCols(claddingPart);

      let contentPart = {title: ui['CONTENT-TITLE'], items: [
          {title: ui['CONTENT-TEMPERATURE'], value: (numeral(c.sections[0].temperature).format('0.0')).toString() + ' °C'},
        ]};
      let calcContentPart = createTableTwoCols(contentPart);

      let environmentPart = {title: ui['ENVIRONMENT-TITLE'], items: [
          {title: ui['ENVIRONMENT-AMBIENT_TEMPERATURE'], value: (c.sections[0].environmentTemperature).toString() + ' °C'},
          {title: ui['ENVIRONMENT-AMBIENT_AIR_VELOCITY'], value: (c.sections[0].environmentAirVelocity).toString() + ' m/s'},
          {title: ui['ENVIRONMENT-RELATIVE_HUMIDITY'], value: (c.sections[0].environmentHumidity).toString() + ' %'}
        ]};
      let calcEnvironmentPart = createTableTwoCols(environmentPart);

      let energyPart = [];
      let calcEnergyPart = [];
      if(c.calculateEnergyConsumption) {
        const energy = ( (typeof r.sectionResults[0].energySource === 'string') ? r.sectionResults[0].energySource : ( (r.sectionResults[0].energySource[printLanguage] !== false) ? r.sectionResults[0].energySource[printLanguage] : r.sectionResults[0].energySource['English']) );
        energyPart = {title: ui['ENERGY-TITLE'], items: [
            {title: ui['ENERGY-ENERGY_SOURCE'], value: energy},
            {title: ui['ENERGY-OPERATING_TIME'], value: (c.energyOperationTime).toString() + ' h'},
            {title: ui['ENERGY-PRICE_OF_ENERGY'], value: (c.energyPrice).toString() + ' ' + ui['COSTS-CURRENCY']},
          ]};
         calcEnergyPart = createTableTwoCols(energyPart);
      }
      let columnObjectInfo = {columns: [calcObjectPart.concat(calcInsulationPart, calcCladdingPart), calcContentPart.concat(calcEnvironmentPart, calcEnergyPart)], columnGap: 10};

      let resultsPart = {items: [
        {title: ui['RESULT-HEAT_LOSS'], value: formatWperArea(numeral(r.sectionResults[0].heatloss).format('0.0'))},
        {title: ui['RESULT-UNINSTALLED_HEAT_LOSS'], value: formatWperArea(numeral(r.sectionResults[0].uninsulatedHeatLoss).format('0.0'))},
        {title: ui['RESULT-TOTAL_HEAT_LOSS'], value: formatW(numeral(r.heatloss).format('0.0'))},
        {title: ui['RESULT-TOTAL_UNINSTALLED_HEAT_LOSS'], value: formatW(numeral(r.uninsulatedHeatLoss).format('0.0'))},
        {title: ui['RESULT-SURFACE_TEMPERATURE'], value: (numeral(r.sectionResults[0].surfaceTemperature).format('0.0')).toString() + ' °C'},
        {title: ui['RESULT-UNINSULATED_SURFACE_TEMPERATURE'], value: (numeral(r.sectionResults[0].uninsulatedSurfaceTemperature).format('0.0')).toString() + ' °C'},
        {title: ui['RESULT-DEW_POINT'], value: (numeral(r.sectionResults[0].dewPoint).format('0.0')).toString() + ' °C'}
        ]};

      // resultsPart.items.push({title: ui['RESULT-TOTAL_UNINSTALLED_HEAT_LOSS'], value:formatW(numeral(r.uninsulatedHeatLoss).format('0.0'))});

      if(app.country === 'Denmark' || (app.country !== 'Sweden' && (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1))) {
        resultsPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
        resultsPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
      }

      if( app.country === 'Sweden' ) {
        resultsPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
        resultsPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE-PIPE-SWEDEN'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
      }

      // if(c.sections[0].supportOfCladding) {
      //   resultsPart.items.push({title: ui['PDF-SUPPORT_ADDITION'], value:(numeral(c.sections[0].influenceOnHeatloss).format('0.0')).toString()+' ss%'});
      // }

      if(c.sections[0].noInsulation !== true) {
        resultsPart.items.push({title: ui['RESULT-NOMINAL_WEIGHT'], value: (numeral(r.sectionResults[0].nominalWeight).format('0.0')).toString() + ' kg/m²'});
      }

      if(c.calculateEnergyConsumption) {
        resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS'], value: (numeral(r.sectionResults[0].annualSavingsKwh).format('0.0')).toString() + ' kWh, ' + (numeral(r.sectionResults[0].annualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
        resultsPart.items.push({title: ui['RESULT-CO2_EMISSIONS'], value: (numeral(r.sectionResults[0].coEmissionReduction).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CO2']});
      }

      let calcResultsPart = createTableTwoCols(resultsPart);

      let objectTitle = createPartTitle(c.name + ' : ' + ui['CALCULATION-FLAT_SURFACE']);

      let resultsTitle = [];
      if ( r.sectionResults[0].layers.length > 3 && (c.sections[0].supportOfCladding || c.sections[0].mechanicalFastener) ) {
        // resultsTitle.push({text:'', pageBreak:'before'})
      }
      resultsTitle.push( createPartTitle(ui['PDF-RESULTS']) );

      if(calculationWarningsIndex > 0) {
        let warningsPart = [];
        for(let w = 0; w < calculationWarnings.length; w++) {
          warningsPart.push({title: (w + 1).toString() + ')', value: calculationWarnings[w]});
        }
        let calcWarningsPart = createWarningsTable(warningsPart);
        let warningsTitle = [];
        if (printProjects) {
          warningsTitle.push({text: '', pageBreak: 'after'});
        }
        warningsTitle.push(createPartTitle(ui['PDF-WARNINGS']));

        calculationsPrintOut.push(objectTitle, columnObjectInfo, resultsTitle, calcResultsPart, warningsTitle, calcWarningsPart);
      } else {
        calculationsPrintOut.push(objectTitle, columnObjectInfo, resultsTitle, calcResultsPart);
      }
    }


// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
/*

########  ##     ##  ######  ########       ###    ##    ## ########     ########  #### ########  ########          #######  ##    ## ########     ######  ########  ######  ######## ####  #######  ##    ##
##     ## ##     ## ##    ##    ##         ## ##   ###   ## ##     ##    ##     ##  ##  ##     ## ##               ##     ## ###   ## ##          ##    ## ##       ##    ##    ##     ##  ##     ## ###   ##
##     ## ##     ## ##          ##        ##   ##  ####  ## ##     ##    ##     ##  ##  ##     ## ##               ##     ## ####  ## ##          ##       ##       ##          ##     ##  ##     ## ####  ##
##     ## ##     ## ##          ##       ##     ## ## ## ## ##     ##    ########   ##  ########  ######   ####    ##     ## ## ## ## ######       ######  ######   ##          ##     ##  ##     ## ## ## ##
##     ## ##     ## ##          ##       ######### ##  #### ##     ##    ##         ##  ##        ##       ####    ##     ## ##  #### ##                ## ##       ##          ##     ##  ##     ## ##  ####
##     ## ##     ## ##    ##    ##       ##     ## ##   ### ##     ##    ##         ##  ##        ##        ##     ##     ## ##   ### ##          ##    ## ##       ##    ##    ##     ##  ##     ## ##   ###
########   #######   ######     ##       ##     ## ##    ## ########     ##        #### ##        ######## ##       #######  ##    ## ########     ######  ########  ######     ##    ####  #######  ##    ##

 */
    if( (c.type == CALCULATION_TYPE_PIPE || c.type == CALCULATION_TYPE_DUCT) && r.sectionResults.length < 2) {
      let adapterPresent = false;

      if (c.type === CALCULATION_TYPE_PIPE || c.sections[0].type === CALCULATION_TYPE_CIRCULAR_DUCT) {
        spacerInputs = [
          {name: ui['SPACER_4'], id: '0.01'},
          {name: ui['SPACER_5'], id: '0.004'},
          {name: ui['SPACER_6'], id: '0.003'},
        ];
      }
      if (c.sections[0].type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
        spacerInputs = [
          {name: ui['SPACER_1'], id: '0.0035'},
          {name: ui['SPACER_2'], id: '0.006'},
          {name: ui['SPACER_3'], id: '0.0085'},
        ];
      }

      if(r.sectionResults[0].warnings && r.sectionResults[0].warnings.object.length > 0) {
        for(let w = 0; w < r.sectionResults[0].warnings.object.length; w++) {
          calculationWarnings.push(r.sectionResults[0].warnings.object[w]);
          calculationWarningsIndex++;
          calculationWarningsIndicator += calculationWarningsIndex + ') ';
        }
      }

      const material = ( (typeof r.sectionResults[0].material === 'string') ? r.sectionResults[0].material : ( (r.sectionResults[0].material[printLanguage] !== false) ? r.sectionResults[0].material[printLanguage] : r.sectionResults[0].material['English']) );
      let objectPart = {title: ui['PDF-TARGET'], items: [
          {title: ui['PDF-MATERIAL'], value: material, warnings: calculationWarningsIndicator},
          {title: ui['SETTINGS-THICKNESS'], value: (c.sections[0].thickness).toString() + ' mm'}
        ]};

      if(c.type == CALCULATION_TYPE_DUCT) {
        let ductType;
        if(c.sections[0].type == CALCULATION_TYPE_RECTANGULAR_DUCT) {
          ductType = ui['CALCULATION-RECTANGULAR_DUCT'];
        } else {
          ductType = ui['CALCULATION-CIRCULAR_DUCT'];
        }
        objectPart.items.push({title: ui['CALCULATION-SELECT_DUCT_TYPE'], value: ductType});
      }

      if(c.calculateTemperatureChange) {
        objectPart.items.push({title: ui['CONTENT-FLOW_VELOCITY'], value: (c.sections[0].flowRate).toString() + ' ' + c.flowRateType});
      }
      // if(c.calculateEnergyConsumption || c.calculateFreezing || c.calculateTemperatureChange || c.calculateEndTemperature ) {
      //   objectPart.items.push({title: ui['GENERAL-LENGHT'], value:(c.sections[0].length).toString()+' m'});
      // }
      objectPart.items.push({title: ui['GENERAL-LENGHT'], value: (c.sections[0].length).toString() + ' m'});
      if(c.type == CALCULATION_TYPE_DUCT) {
        if(c.sections[0].type == CALCULATION_TYPE_RECTANGULAR_DUCT) {
          objectPart.items.push({title: ui['GENERAL-WIDTH'], value: (numeral(c.sections[0].width).format('0')).toString() + ' mm'});
          objectPart.items.push({title: ui['GENERAL-HEIGHT'], value: (numeral(c.sections[0].height).format('0')).toString() + ' mm'});
        } else {
          objectPart.items.push({title: ui['GENERAL-OUTER_DIAMETER'], value: (numeral(c.sections[0].outerDiameter).format('0')).toString() + ' mm'});
        }
      } else {
        objectPart.items.push({title: ui['GENERAL-OUTER_DIAMETER'], value: (numeral(c.sections[0].outerDiameter).format('0.0')).toString() + ' mm'});
      }

      objectPart.items.push({ title: ui['GENERAL_ORIENTATION'], value: (c.sections[0].direction === 'hor' ? ui['TARGET_HORIZONTAL'] : ui['TARGET_VERTICAL']) });

      let calcObjectPart = createTableTwoCols(objectPart);

      let insulations = [];
      if(c.sections[0].noInsulation) {
        insulations.push({title: ui['GENERAL-NO_INSULATION'], detail: '', value: ''});
      } else {
        for(let j = 0; j < r.sectionResults[0].layers.length; j++) {
          calculationWarningsIndicator = '';
          if(r.sectionResults[0].layers[j].warnings.length > 0) {
            for(let w = 0; w < r.sectionResults[0].layers[j].warnings.length; w++) {
              calculationWarnings.push(r.sectionResults[0].layers[j].warnings[w]);
              calculationWarningsIndex++;
              calculationWarningsIndicator += ' ' + calculationWarningsIndex + ')';
            }
          }
          insulations.push({
            title: r.sectionResults[0].layers[j].product.name,
            detail: (r.sectionResults[0].layers[j].product.thickness).toString() + ' mm',
            value: (numeral(r.sectionResults[0].layers[j].surfaceTemperature).format('0.0')).toString() + ' °C',
            warnings: calculationWarningsIndicator
          });
        }
      }
      let insulationPart = {
        title: ui['PDF-INSULATIONS'], items: insulations
      };
      let calcInsulationPart =  createTableThreeCols(insulationPart);

      let claddingPart = {};
      if(c.sections[0].noInsulation) {
        claddingPart = {title: ui['INSULATION-CLADDING'], items: [
          {title: ui['GENERAL-NO_CLADDING'], value: ''},
        ]};
      } else {
        calculationWarningsIndicator = '';
        if(r.sectionResults[0].warnings && r.sectionResults[0].warnings.surface.length > 0) {
          for(let w = 0; w < r.sectionResults[0].warnings.surface.length; w++) {
            calculationWarnings.push(r.sectionResults[0].warnings.surface[w]);
            calculationWarningsIndex++;
            calculationWarningsIndicator += calculationWarningsIndex + ') ';
          }
        }
        const cladding = ( (typeof r.sectionResults[0].cladding === 'string') ? r.sectionResults[0].cladding : ( (r.sectionResults[0].cladding[printLanguage] !== false) ? r.sectionResults[0].cladding[printLanguage] : r.sectionResults[0].cladding['English']) );
        claddingPart = {title: ui['INSULATION-CLADDING'], items: [
          {title: cladding, value: ui['INSULATION-EMISSITIVITY'] + ': ' + (c.sections[0].emissivity).toString(), warnings: calculationWarningsIndicator},
        ]
        };

        if(c.sections[0].suspensionOfTarget) {
          claddingPart.items.push({title: ui['PDF-SUSPENSION_ADDITION'], value: (numeral(c.sections[0].suspensionInfluence).format('0.0')).toString() + ' %'});
        }

        if (c.sections[0].supportOfCladding) {
          const type = spacerInputs.find(item => item.id === c.sections[0].influenceOnHeatloss).name || 'not found';
          if (c.sections[0].type == CALCULATION_TYPE_CIRCULAR_DUCT || c.type === CALCULATION_TYPE_PIPE) {
            claddingPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}` });
          } else {
            claddingPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}, ${(numeral(c.sections[0].spacersPerM).format('0')).toString()} / m²` });
          }
        }

        if (c.sections[0].mechanicalFastener) {
          const type = mechanicalFastenersInputs.find(item => item.id === c.sections[0].mechanicalInfluence).name || 'not found';
          claddingPart.items.push({ title: ui['GENERAL_MECH_FASTENER'], value: `${type}, ${(numeral(c.sections[0].mechanicalPerM).format('0')).toString()} / m²` });
        }
      }
      let calcCladdingPart = createTableTwoCols(claddingPart);

      const content = ( (typeof r.sectionResults[0].content === 'string') ? r.sectionResults[0].content : ( (r.sectionResults[0].content[printLanguage] !== false) ? r.sectionResults[0].content[printLanguage] : r.sectionResults[0].content['English']) );
      let contentPart = {title: ui['CONTENT-TITLE'], items: [
          {title: ui['PDF-TYPE'], value: content},
          {title: ui['CONTENT-TEMPERATURE'], value: (numeral(c.sections[0].temperature).format('0.0')).toString() + ' °C'},
        ]};
      if(c.calculateFreezing) {
        contentPart.items.push({title: ui['CONTENT-FREEZING_PERCENTAGE'], value: (c.sections[0].freezingPercentage).toString() + ' %'});
      }
      if(c.calculateEndTemperature) {
        contentPart.items.push({title: ui['CONTENT-THRESHOLD_TEMPERATURE'], value: (numeral(c.sections[0].finalTemperature).format('0.0')).toString() + ' °C'});
      }
      let calcContentPart = createTableTwoCols(contentPart);

      let environmentPart = {title: ui['ENVIRONMENT-TITLE'], items: [
          {title: ui['ENVIRONMENT-AMBIENT_TEMPERATURE'], value: (c.sections[0].environmentTemperature).toString() + ' °C'},
          {title: ui['ENVIRONMENT-AMBIENT_AIR_VELOCITY'], value: (c.sections[0].environmentAirVelocity).toString() + ' m/s'},
          {title: ui['ENVIRONMENT-RELATIVE_HUMIDITY'], value: (c.sections[0].environmentHumidity).toString() + ' %'}
        ]};
      let calcEnvironmentPart = createTableTwoCols(environmentPart);

      let energyPart = [];
      let calcEnergyPart = [];
      if(c.calculateEnergyConsumption) {
        const energy = ( (typeof r.sectionResults[0].energySource === 'string') ? r.sectionResults[0].energySource : ( (r.sectionResults[0].energySource[printLanguage] !== false) ? r.sectionResults[0].energySource[printLanguage] : r.sectionResults[0].energySource['English']) );
        energyPart = {title: ui['ENERGY-TITLE'], items: [
            {title: ui['ENERGY-ENERGY_SOURCE'], value: energy},
            {title: ui['ENERGY-OPERATING_TIME'], value: (c.energyOperationTime).toString() + ' h'},
            {title: ui['ENERGY-PRICE_OF_ENERGY'], value: (c.energyPrice).toString() + ' ' + ui['COSTS-CURRENCY']},
          ]};
         calcEnergyPart = createTableTwoCols(energyPart);
      }

      let adaptersPart = {};
      let calcAdaptersPart = [];
      if(c.sections[0].calculateAdapters && c.sections[0].adapters && c.sections[0].adapters.length > 0) {
        adaptersPart = {title: ui['PDF-VALVES_AND_FITTINGS'], items: []};
        for(let i = 0; i < c.sections[0].adapters.length; i++) {
          let adapterTitle = '';
          if(c.sections[0].adapters[i].Nid < 0) {
            adapterTitle = ui['GENERAL-CUSTOM'];
          } else {
            adapterTitle = (getItemByNid(c.sections[0].adapters[i].Nid, adapters))[printLanguage];
            if(adapterTitle === false) {
              adapterTitle = (getItemByNid(c.sections[0].adapters[i].Nid, adapters))['English'];
            }
          }
          if(c.sections[0].adapters[i].insCoverage != 0) {
            adaptersPart.items.push({title: adapterTitle,
                            insulation: ui['ADAPTERS-INSULATION_COVERAGE'] + ' ' + numeral(c.sections[0].adapters[i].insCoverage).format('0').toString() + '% / ' + numeral(c.sections[0].adapters[i].insThickness).format('0').toString() + 'mm',
                            count: numeral(c.sections[0].adapters[i].count).format('0').toString() + ' ' + ui['PDF-VALVES_AND_FITTINGS_UNITS'],
                            eq: ui['ADAPTERS-EQUIVALENCE'] + ' ' + numeral(c.sections[0].adapters[i].Equivalence).format('0.0').toString() + ' m',
                            value: formatW(numeral(r.sectionResults[0].adapterHeatloss[i]).format('0.0')) + '/' + ui['PDF-VALVES_AND_FITTINGS_UNIT']});
          } else {
            adaptersPart.items.push({title: adapterTitle,
                            insulation: '',
                            count: numeral(c.sections[0].adapters[i].count).format('0').toString() + ' ' + ui['PDF-VALVES_AND_FITTINGS_UNITS'],
                            eq: ui['ADAPTERS-EQUIVALENCE'] + ' ' + numeral(c.sections[0].adapters[i].Equivalence).format('0.0').toString() + ' m',
                            value: formatW(numeral(r.sectionResults[0].adapterHeatloss[i]).format('0.0')) + '/' + ui['PDF-VALVES_AND_FITTINGS_UNIT']});
          }
        }
        calcAdaptersPart = createTableFiveCols(adaptersPart);
      }

      let columnObjectInfo;
//      if(c.sections[0].adapters && c.sections[0].adapters.length) {
//        columnObjectInfo = {columns: [calcObjectPart.concat(calcInsulationPart,calcCladdingPart), calcContentPart.concat(calcEnvironmentPart,calcEnergyPart,calcAdaptersPart)], columnGap:10};
//      } else {
        columnObjectInfo = {columns: [calcObjectPart.concat(calcInsulationPart, calcCladdingPart), calcContentPart.concat(calcEnvironmentPart, calcEnergyPart)], columnGap: 10};
//      }

      let resultsPart;
      if(c.sections[0].heatlossUnitType == 'm') {
        resultsPart = {items: [
          {title: ui['RESULT-HEAT_LOSS'], value: formatWperLength(numeral(r.sectionResults[0].heatloss).format('0.0'))},
          {title: ui['RESULT-UNINSTALLED_HEAT_LOSS'], value: formatWperLength(numeral(r.sectionResults[0].uninsulatedHeatLoss).format('0.0'))}
          ]};
      } else {
        resultsPart = {items: [
          {title: ui['RESULT-HEAT_LOSS'], value: formatWperArea(numeral(r.sectionResults[0].heatlossArea).format('0.0'))},
          {title: ui['RESULT-UNINSTALLED_HEAT_LOSS'], value: formatWperArea(numeral(r.sectionResults[0].uninsulatedHeatLossArea).format('0.0'))}
          ]};
      }

      if(app.country === 'Denmark' || (app.country !== 'Sweden' && (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) ) {
        resultsPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
        resultsPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
      }

      if(app.country === 'Sweden' ) {
        resultsPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
        if(c.type === CALCULATION_TYPE_DUCT ) {
          resultsPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
        } else {
          resultsPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE-PIPE-SWEDEN'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].uKlasseUnit});
        }
      }

      // if(c.sections[0].supportOfCladding) {
      //   resultsPart.items.push({title: ui['PDF-SUPPORT_ADDITION'], value:(numeral(c.sections[0].influenceOnHeatloss).format('0.0')).toString()+' %'});
      // }

      // if(c.sections[0].suspensionOfTarget) {
      //   resultsPart.items.push({title: ui['PDF-SUSPENSION_ADDITION'], value:(numeral(c.sections[0].suspensionInfluence).format('0.0')).toString()+' %'});
      // }

      if(c.calculateTemperatureChange) {
        resultsPart.items.push({title: ui['RESULT-TOTAL_HEAT_LOSS'], value: formatW(numeral(r.totalPipelineHeatLoss).format('0.0'))});
        resultsPart.items.push({title: ui['RESULT-TOTAL_UNINSTALLED_HEAT_LOSS'], value: formatW(numeral(r.totalUninsulatedPipelineHeatLoss).format('0.0'))});
      }

      if(c.sections[0].calculateAdapters) {
        resultsPart.items.push({title: ui['RESULT-TOTAL_ADAPTERS_HEATLOSS'], value: formatW(numeral(r.totalAdaptersHeatloss).format('0.0')) });
        if(c.calculateTemperatureChange) {
          resultsPart.items.push({title: ui['RESULT-TOTAL_HEATLOSS_WITH_ADAPTERS'], value: formatW(numeral(r.totalAdaptersHeatloss + r.totalPipelineHeatLoss).format('0.0')) });
        }
        adapterPresent = true;
      }

      resultsPart.items.push({title: ui['RESULT-SURFACE_TEMPERATURE'], value: (numeral(r.sectionResults[0].surfaceTemperature).format('0.0')).toString() + ' °C'});
      resultsPart.items.push({title: ui['RESULT-UNINSULATED_SURFACE_TEMPERATURE'], value: (numeral(r.sectionResults[0].uninsulatedSurfaceTemperature).format('0.0')).toString() + ' °C'});
      resultsPart.items.push({title: ui['RESULT-DEW_POINT'], value: (numeral(r.sectionResults[0].dewPoint).format('0.0')).toString() + ' °C'});

      if(c.calculateTemperatureChange) {
        resultsPart.items.push({title: ui['RESULT-TEMPERATURE_CHANGE'], value: (numeral(r.sectionResults[0].temperatureDrop).format('0.0')).toString() + ' °C'});
      }

      if(c.sections[0].noInsulation !== true) {
        resultsPart.items.push({title: ui['RESULT-NOMINAL_WEIGHT'], value: (numeral(r.sectionResults[0].nominalWeight).format('0.0')).toString() + ' kg/m'});
      }

      if(c.sections[0].calculateFreezing && r.sectionResults[0].freezingTime != '-') {
        resultsPart.items.push({title: ui['RESULT-FREEZING_STARTS'], value: (numeral(r.sectionResults[0].freezingTime).format('0.0')).toString() + ' h'});
        resultsPart.items.push({title: ui['RESULT-FROZEN_AT'] + ' ' + (c.sections[0].freezingPercentage).toString() + ' %', value: (numeral(r.sectionResults[0].freezingTimeToValue).format('0.0')).toString() + ' h'});
        resultsPart.items.push({title: ui['RESULT-HEATING_CABLE_WATTAGE'], value: formatWperLength(numeral(r.sectionResults[0].freezingResistance).format('0.0'))});
      } else if(c.sections[0].calculateFreezing) {
        resultsPart.items.push({title: ui['RESULT-FREEZING_STARTS'], value: '- h'});
        resultsPart.items.push({title: ui['RESULT-FROZEN_AT'] + ' ' + (c.sections[0].freezingPercentage).toString() + ' %', value: '- h'});
        resultsPart.items.push({title: ui['RESULT-HEATING_CABLE_WATTAGE'], value: '- W/m'});
      }

      if(c.calculateEnergyConsumption) {
        resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS'], value: (numeral(r.sectionResults[0].annualSavingsKwh).format('0.0')).toString() + ' kWh, ' + (numeral(r.sectionResults[0].annualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
        resultsPart.items.push({title: ui['RESULT-CO2_EMISSIONS'], value: (numeral(r.sectionResults[0].coEmissionReduction).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CO2']});

        if(r.totalUninsulatedAdaptersHeatloss !== null) {
          resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS_ADAPTERS'], value: (numeral(r.totalAdaptersAnnualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
        }
      }

      if(c.calculateEndTemperature && r.sectionResults[0].coolingTime != '-') {
        resultsPart.items.push({title: ui['RESULT-COOLING_TIME'], value: (numeral(r.sectionResults[0].coolingTime).format('0.0')).toString() + ' h'});
      } else if(c.calculateEndTemperature) {
        resultsPart.items.push({title: ui['RESULT-COOLING_TIME'], value: '- h'});
      }

      let calcResultsPart = createTableTwoCols(resultsPart);

      let objectTitle;
      if(c.type == CALCULATION_TYPE_PIPE) {
        objectTitle = createPartTitle(c.name + ' : ' + ui['CALCULATION-PIPE']);
      } else {
        objectTitle = createPartTitle(c.name + ' : ' + ui['CALCULATION-DUCT']);
      }

      let resultsTitle = [];
      if ( c.sections[0].supportOfCladding || c.sections[0].mechanicalFastener || c.sections[0].calculateAdapters ) {
        // resultsTitle.push({text:'', pageBreak:'before'})
      }
      resultsTitle.push( createPartTitle(ui['PDF-RESULTS']) );

      if(calculationWarningsIndex > 0) {
        let warningsPart = [];
        for(let w = 0; w < calculationWarnings.length; w++) {
          warningsPart.push({title: (w + 1).toString() + ')', value: calculationWarnings[w]});
        }
        let calcWarningsPart = createWarningsTable(warningsPart);
        let warningsTitle = [];
        if (printProjects) {
          warningsTitle.push({text: '', pageBreak: 'after'});
        }
        warningsTitle.push(createPartTitle(ui['PDF-WARNINGS']));

        if(c.sections[0].adapters && c.sections[0].adapters.length) {
          calculationsPrintOut.push(objectTitle, columnObjectInfo, calcAdaptersPart, {text: '', pageBreak: 'after'}, resultsTitle, calcResultsPart, warningsTitle, calcWarningsPart);
        } else {
          calculationsPrintOut.push(objectTitle, columnObjectInfo, resultsTitle, calcResultsPart, warningsTitle, calcWarningsPart);
        }
      } else {
        if(c.sections[0].calculateAdapters && c.sections[0].adapters && c.sections[0].adapters.length) {
          calculationsPrintOut.push(objectTitle, columnObjectInfo, calcAdaptersPart, {text: '', pageBreak: 'after'}, resultsTitle, calcResultsPart);
        } else {
          calculationsPrintOut.push(objectTitle, columnObjectInfo, resultsTitle, calcResultsPart);
        }
      }

      if(adapterPresent && (c.calculateEnergyConsumption || c.calculateFreezing || c.calculateTemperatureChange || c.calculateEndTemperature ) ) {
        calculationsPrintOut.push({text: ui['PDF-VALVES_AND_FITTINGS_NOTICE'], style: 'adapterNotice'});
      }
    }

// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
/*

########  #### ########  ######## ##       #### ##    ## ########
##     ##  ##  ##     ## ##       ##        ##  ###   ## ##
##     ##  ##  ##     ## ##       ##        ##  ####  ## ##
########   ##  ########  ######   ##        ##  ## ## ## ######
##         ##  ##        ##       ##        ##  ##  #### ##
##         ##  ##        ##       ##        ##  ##   ### ##
##        #### ##        ######## ######## #### ##    ## ########

 */

    if( (c.type == CALCULATION_TYPE_PIPE) && r.sectionResults.length > 1) {
      let adapterPresent = false;
      spacerInputs = [
        {name: ui['SPACER_4'], id: '0.01'},
        {name: ui['SPACER_5'], id: '0.004'},
        {name: ui['SPACER_6'], id: '0.003'},
      ];

      const content = ( (typeof r.sectionResults[0].content === 'string') ? r.sectionResults[0].content : ( (r.sectionResults[0].content[printLanguage] !== false) ? r.sectionResults[0].content[printLanguage] : r.sectionResults[0].content['English']) );
      let contentPart = {title: ui['CONTENT-TITLE'], items: [
          {title: ui['PDF-TYPE'], value: content},
          {title: ui['CONTENT-TEMPERATURE'], value: (numeral(c.sections[0].temperature).format('0.0')).toString() + ' °C'},
        ]};
        let calcContentPart = createTableTwoCols(contentPart);

      let energyPart = [];
      let calcEnergyPart = [];
      if(c.calculateEnergyConsumption) {
        const energy = ( (typeof r.sectionResults[0].energySource === 'string') ? r.sectionResults[0].energySource : ( (r.sectionResults[0].energySource[printLanguage] !== false) ? r.sectionResults[0].energySource[printLanguage] : r.sectionResults[0].energySource['English']) );
        energyPart = {title: ui['ENERGY-TITLE'], items: [
            {title: ui['ENERGY-ENERGY_SOURCE'], value: energy},
            {title: ui['ENERGY-OPERATING_TIME'], value: (c.energyOperationTime).toString() + ' h'},
            {title: ui['ENERGY-PRICE_OF_ENERGY'], value: (c.energyPrice).toString() + ' ' + ui['COSTS-CURRENCY']},
          ]};
         calcEnergyPart = createTableTwoCols(energyPart);
      }

      let resultsPart = {items: [
        {title: ui['RESULT-TOTAL_HEAT_LOSS'], value: formatW(numeral(r.totalPipelineHeatLoss).format('0.0'))},
        {title: ui['RESULT-TOTAL_UNINSTALLED_HEAT_LOSS'], value: formatW(numeral(r.totalUninsulatedPipelineHeatLoss).format('0.0'))},
        {title: ui['RESULT-FINAL_TEMP_OF_CONTENTS'], value: (numeral(r.finalPipelineTemperature).format('0.0')).toString() + ' °C'}
        ]};

      if(r.totalAdaptersHeatLoss !== null) {
        resultsPart.items.push({title: ui['RESULT-TOTAL_ADAPTERS_HEATLOSS'], value: formatW(numeral(r.totalAdaptersHeatloss).format('0.0')) });
        resultsPart.items.push({title: ui['RESULT-TOTAL_HEATLOSS_WITH_ADAPTERS'], value: formatW(numeral(r.totalAdaptersHeatloss + r.totalPipelineHeatLoss).format('0.0')) });
      }

      if(c.calculateEnergyConsumption) {
        resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS'], value: (numeral(r.totalAnnualSavingsKwh).format('0.0')).toString() + ' kWh, ' + (numeral(r.totalAnnualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
        resultsPart.items.push({title: ui['RESULT-CO2_EMISSIONS'], value: (numeral(r.totalCOemissionReduction).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CO2']});
        if(r.totalUninsulatedAdaptersHeatloss !== null) {
          resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS_ADAPTERS'], value: (numeral(r.totalAdaptersAnnualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
        }
      }

      let calcResultsPart = createTableTwoCols(resultsPart);


      let objectTitle = createPartTitle(c.name + ' : ' + ui['CALCULATION-PIPE']);

      let resultsTitle = createPartTitle(ui['RESULT-RESULTS_FOR_PIPELINE']);

      let columnObjectInfo = {columns: [objectTitle.concat(calcContentPart, calcEnergyPart), resultsTitle.concat(calcResultsPart)], columnGap: 10};

      calculationsPrintOut.push(columnObjectInfo);
      calculationsPrintOut.push({text: '', pageBreak: 'after'});

      for(let j = 0; j < r.sectionResults.length; j++) {
        calculationWarningsIndex = 0;
        calculationWarnings = [];

        calculationWarningsIndicator = '';
        if(r.sectionResults[j].warnings && r.sectionResults[j].warnings.object.length > 0) {
          for(let w = 0; w < r.sectionResults[j].warnings.object.length; w++) {
            calculationWarnings.push(r.sectionResults[j].warnings.object[w]);
            calculationWarningsIndex++;
            calculationWarningsIndicator += calculationWarningsIndex + ') ';
          }
        }
        const material = ( (typeof r.sectionResults[j].material === 'string') ? r.sectionResults[j].material : ( (r.sectionResults[j].material[printLanguage] !== false) ? r.sectionResults[j].material[printLanguage] : r.sectionResults[j].material['English']) );
        let objectPart = {items: [
            {title: ui['PDF-MATERIAL'], value: material, warnings: calculationWarningsIndicator},
            {title: ui['GENERAL-OUTER_DIAMETER'], value: (numeral(c.sections[j].outerDiameter).format('0.0')).toString() + ' mm'},
            {title: ui['SETTINGS-THICKNESS'], value: c.sections[j].thickness + ' mm'}
          ]};
        if(c.calculateEnergyConsumption || c.calculateFreezing || c.calculateTemperatureChange || c.calculateEndTemperature ) {
          objectPart.items.push({title: ui['CONTENT-FLOW_VELOCITY'], value: (c.sections[j].flowRate).toString() + ' ' + c.flowRateType});
          objectPart.items.push({title: ui['GENERAL-LENGHT'], value: (c.sections[j].length).toString() + ' m'});
        }
        if(c.calculateEndTemperature) {
          objectPart.items.push({title: ui['CONTENT-THRESHOLD_TEMPERATURE'], value: (numeral(c.sections[j].finalTemperature).format('0.0')).toString() + ' °C'});
        }
        let calcObjectPart = createTableTwoCols(objectPart);

        let environmentPart = {title: ui['ENVIRONMENT-TITLE'], items: [
            {title: ui['ENVIRONMENT-AMBIENT_TEMPERATURE'], value: (c.sections[j].environmentTemperature).toString() + ' °C'},
            {title: ui['ENVIRONMENT-AMBIENT_AIR_VELOCITY'], value: (c.sections[j].environmentAirVelocity).toString() + ' m/s'},
            {title: ui['ENVIRONMENT-RELATIVE_HUMIDITY'], value: (c.sections[j].environmentHumidity).toString() + ' %'}
          ]};
        let calcEnvironmentPart = createTableTwoCols(environmentPart);

        let insulations = [];
        if(c.sections[j].noInsulation) {
          insulations.push({title: ui['GENERAL-NO_INSULATION'], detail: '', value: ''});
        } else {
          for(let k = 0; k < r.sectionResults[j].layers.length; k++) {
            calculationWarningsIndicator = '';
            if(r.sectionResults[j].layers[k].warnings.length > 0) {
              for(let w = 0; w < r.sectionResults[j].layers[k].warnings.length; w++) {
                calculationWarnings.push(r.sectionResults[j].layers[k].warnings[w]);
                calculationWarningsIndex++;
                calculationWarningsIndicator += ' ' + calculationWarningsIndex + ')';
              }
            }

            insulations.push({
              title: r.sectionResults[j].layers[k].product.name,
              detail: (r.sectionResults[j].layers[k].product.thickness).toString() + ' mm',
              value: (numeral(r.sectionResults[j].layers[k].surfaceTemperature).format('0.0')).toString() + ' °C',
              warnings: calculationWarningsIndicator
            });
          }
        }
        let insulationPart = {
          title: ui['PDF-INSULATIONS'], items: insulations
        };
        let calcInsulationPart =  createTableThreeCols(insulationPart);

        let claddingPart = {};
        if(c.sections[j].noInsulation) {
          claddingPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: ui['GENERAL-NO_CLADDING'], value: ''},
          ]};
        } else {
          calculationWarningsIndicator = '';
          if(r.sectionResults[j].warnings && r.sectionResults[j].warnings.surface.length > 0) {
            for(let w = 0; w < r.sectionResults[j].warnings.surface.length; w++) {
              calculationWarnings.push(r.sectionResults[j].warnings.surface[w]);
              calculationWarningsIndex++;
              calculationWarningsIndicator += calculationWarningsIndex + ') ';
            }
          }
          const cladding = ( (typeof r.sectionResults[j].cladding === 'string') ? r.sectionResults[j].cladding : ( (r.sectionResults[j].cladding[printLanguage] !== false) ? r.sectionResults[j].cladding[printLanguage] : r.sectionResults[j].cladding['English']) );
          claddingPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: cladding, value: ui['INSULATION-EMISSITIVITY'] + ': ' + (c.sections[j].emissivity).toString(), warnings: calculationWarningsIndicator},
          ]
          };
          if(c.sections[j].suspensionOfTarget) {
            claddingPart.items.push({title: ui['PDF-SUSPENSION_ADDITION'], value: (numeral(c.sections[j].suspensionInfluence).format('0.0')).toString() + ' %'});
          }

          if (c.sections[j].supportOfCladding) {
            const type = spacerInputs.find(item => item.id === c.sections[j].influenceOnHeatloss).name || 'not found';
            claddingPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}` });
            // claddingPart.items.push({ title: 'Spacers', value: `${type}, ${(numeral(c.sections[j].spacersPerM).format('0')).toString()} per m²` });
          }

          if (c.sections[j].mechanicalFastener) {
            const type = mechanicalFastenersInputs.find(item => item.id === c.sections[j].mechanicalInfluence).name || 'not found';
            claddingPart.items.push({ title: ui['GENERAL_MECH_FASTENER'], value: `${type}, ${(numeral(c.sections[j].mechanicalPerM).format('0')).toString()} / m²` });
          }
        }
        let calcCladdingPart = createTableTwoCols(claddingPart);

        let adaptersPart;
        let calcAdaptersPart;
        if(c.sections[j].calculateAdapters && c.sections[j].adapters && c.sections[j].adapters.length > 0) {
          adapterPresent = true;

          adaptersPart = {title: ui['PDF-VALVES_AND_FITTINGS'], items: []};
          for(let k = 0; k < c.sections[j].adapters.length; k++) {
            let adapterTitle = '';
            if(c.sections[j].adapters[k].Nid < 0) {
              adapterTitle = ui['GENERAL-CUSTOM'];
            } else {
              adapterTitle = (getItemByNid(c.sections[j].adapters[k].Nid, adapters))[printLanguage];
              if(adapterTitle === false) {
                adapterTitle = (getItemByNid(c.sections[j].adapters[k].Nid, adapters))['English'];
              }
            }
            if(c.sections[j].adapters[k].insCoverage != 0) {
              adaptersPart.items.push({title: adapterTitle,
                              insulation: ui['ADAPTERS-INSULATION_COVERAGE'] + ' ' + numeral(c.sections[j].adapters[k].insCoverage).format('0').toString() + '% / ' + numeral(c.sections[j].adapters[k].insThickness).format('0').toString() + 'mm',
                              count: numeral(c.sections[j].adapters[k].count).format('0').toString() + ' ' + ui['PDF-VALVES_AND_FITTINGS_UNITS'],
                              eq: ui['ADAPTERS-EQUIVALENCE'] + ' ' + numeral(c.sections[j].adapters[k].Equivalence).format('0.0').toString() + ' m',
                              value: formatW(numeral(r.sectionResults[j].adapterHeatloss[k]).format('0.0')) + '/' + ui['PDF-VALVES_AND_FITTINGS_UNIT']});
            } else {
              adaptersPart.items.push({title: adapterTitle,
                              insulation: '',
                              count: numeral(c.sections[j].adapters[k].count).format('0').toString() + ' ' + ui['PDF-VALVES_AND_FITTINGS_UNITS'],
                              eq: ui['ADAPTERS-EQUIVALENCE'] + ' ' + numeral(c.sections[j].adapters[k].Equivalence).format('0.0').toString() + ' m',
                              value: formatW(numeral(r.sectionResults[j].adapterHeatloss[k]).format('0.0')) + '/' + ui['PDF-VALVES_AND_FITTINGS_UNIT']});
            }
          }
          calcAdaptersPart = createTableFiveCols(adaptersPart);
        }


        let resultsPart;
        if(c.sections[0].heatlossUnitType == 'm') {
          resultsPart = {items: [
            {title: ui['RESULT-HEAT_LOSS'], value: formatWperLength(numeral(r.sectionResults[j].heatloss).format('0.0'))},
            {title: ui['PDF-SECTION_TOTAL_HEAT_LOSS'], value: formatW(numeral(r.sectionResults[j].totalSectionHeatloss).format('0.0'))},
            {title: ui['RESULT-UNINSTALLED_HEAT_LOSS'], value: formatWperLength(numeral(r.sectionResults[j].uninsulatedHeatLoss).format('0.0'))}
            ]};
        } else {
          resultsPart = {items: [
            {title: ui['RESULT-HEAT_LOSS'], value: formatWperArea(numeral(r.sectionResults[j].heatlossArea).format('0.0'))},
            {title: ui['PDF-SECTION_TOTAL_HEAT_LOSS'], value: formatW(numeral(r.sectionResults[j].totalSectionHeatloss).format('0.0'))},
            {title: ui['RESULT-UNINSTALLED_HEAT_LOSS'], value: formatWperArea(numeral(r.sectionResults[j].uninsulatedHeatLossArea).format('0.0'))}
            ]};
        }

        if(app.country === 'Denmark' || ( app.country !== 'Sweden' && (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) ) {
          resultsPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[j].uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[j].uKlasseUnit});
          resultsPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[j].klasse + 1) + ')' ), value: (numeral(r.sectionResults[j].uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[j].uKlasseUnit});
        }

        if(app.country === 'Sweden' ) {
          resultsPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[j].uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[j].uKlasseUnit});
          resultsPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE-PIPE-SWEDEN'] + ' ' + (c.sections[j].klasse + 1) + ')' ), value: (numeral(r.sectionResults[j].uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[j].uKlasseUnit});
        }

        // if(c.sections[j].supportOfCladding) {
        //   resultsPart.items.push({title: ui['PDF-SUPPORT_ADDITION'], value:(numeral(c.sections[j].influenceOnHeatloss).format('0.0')).toString()+' %'});
        // }

        // if(c.sections[j].suspensionOfTarget) {
        //   resultsPart.items.push({title: ui['PDF-SUSPENSION_ADDITION'], value:(numeral(c.sections[j].suspensionInfluence).format('0.0')).toString()+' %'});
        // }


        if(c.sections[j].calculateAdapters) {
          resultsPart.items.push({title: ui['RESULT-ADAPTERS_HEATLOSS'], value: formatW(numeral(r.sectionResults[j].adapterHeatlossTotal).format('0.0')) });
          resultsPart.items.push({title: ui['RESULT-HEATLOSS_WITH_ADAPTERS'], value: formatW(numeral(r.sectionResults[j].adapterHeatlossTotal + r.sectionResults[j].totalSectionHeatloss).format('0.0')) });
        }

        resultsPart.items.push({title: ui['RESULT-SURFACE_TEMPERATURE'], value: (numeral(r.sectionResults[j].surfaceTemperature).format('0.0')).toString() + ' °C'});
        resultsPart.items.push({title: ui['RESULT-UNINSULATED_SURFACE_TEMPERATURE'], value: (numeral(r.sectionResults[j].uninsulatedSurfaceTemperature).format('0.0')).toString() + ' °C'});
        resultsPart.items.push({title: ui['RESULT-DEW_POINT'], value: (numeral(r.sectionResults[j].dewPoint).format('0.0')).toString() + ' °C'});
        resultsPart.items.push({title: ui['RESULT-TEMPERATURE_CHANGE'], value: (numeral(r.sectionResults[j].temperatureDrop).format('0.0')).toString() + ' °C'});
        if(c.sections[j].noInsulation !== true) {
          resultsPart.items.push({title: ui['RESULT-NOMINAL_WEIGHT'], value: (numeral(r.sectionResults[j].nominalWeight).format('0.0')).toString() + ' kg/m'});
        }

        if(c.calculateEndTemperature && r.sectionResults[j].coolingTime != '-') {
          resultsPart.items.push({title: ui['RESULT-COOLING_TIME'], value: (numeral(r.sectionResults[j].coolingTime).format('0.0')).toString() + ' h'});
        } else if(c.calculateEndTemperature) {
          resultsPart.items.push({title: ui['RESULT-COOLING_TIME'], value: '- h'});
        }

        if(c.calculateEnergyConsumption) {
          resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS'], value: (numeral(r.sectionResults[j].annualSavingsKwh).format('0.0')).toString() + ' kWh, ' + (numeral(r.sectionResults[j].annualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
          resultsPart.items.push({title: ui['RESULT-CO2_EMISSIONS'], value: (numeral(r.sectionResults[j].coEmissionReduction).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CO2']});
        }


        let calcResultsPart = createTableTwoCols(resultsPart);

        let sectionTitle = createPartTitle(ui['CALCULATION-PIPE'] + ' : ' + ui['PDF-SECTION'] + ' ' + (j + 1).toString());

        let sectionResultsTitle = createPartTitle(ui['PDF-RESULTS']);

        let columnObjectInfo;
//        if(c.sections[j].adapters && c.sections[j].adapters.length >0) {
//          columnObjectInfo = {columns: [sectionTitle.concat(calcObjectPart,calcEnvironmentPart,calcInsulationPart,calcCladdingPart),sectionResultsTitle.concat(calcResultsPart,calcAdaptersPart)], columnGap:10};
//        } else {
          columnObjectInfo = {columns: [sectionTitle.concat(calcObjectPart, calcEnvironmentPart, calcInsulationPart, calcCladdingPart), sectionResultsTitle.concat(calcResultsPart)], columnGap: 10};
//        }

        if(calculationWarningsIndex > 0) {
          let warningsPart = [];
          for(let w = 0; w < calculationWarnings.length; w++) {
            warningsPart.push({title: (w + 1).toString() + ')', value: calculationWarnings[w]});
          }
          let calcWarningsPart = createWarningsTable(warningsPart);

          let warningsTitle = [];
          if (printProjects) {
            warningsTitle.push({text: '', pageBreak: 'after'});
          }
          warningsTitle.push(createPartTitle(ui['PDF-WARNINGS']));

          if(c.sections[j].calculateAdapters && c.sections[j].adapters && c.sections[j].adapters.length > 0) {
            calculationsPrintOut.push(columnObjectInfo, calcAdaptersPart, warningsTitle, calcWarningsPart);
          } else {
            calculationsPrintOut.push(columnObjectInfo, warningsTitle, calcWarningsPart);
          }
        } else {
          if(c.sections[j].calculateAdapters && c.sections[j].adapters && c.sections[j].adapters.length > 0) {
            calculationsPrintOut.push(columnObjectInfo, calcAdaptersPart);
          } else {
            calculationsPrintOut.push(columnObjectInfo);
          }
        }

        if(adapterPresent) {
          calculationsPrintOut.push({text: ui['PDF-VALVES_AND_FITTINGS_NOTICE'], style: 'adapterNotice'});
          adapterPresent = false;
        }

        if(j < r.sectionResults.length - 1) {
          calculationsPrintOut.push({text: '', pageBreak: 'after'});
        }
      }
    }

// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
/*

########  ##     ##  ######  ######## ##       #### ##    ## ########
##     ## ##     ## ##    ##    ##    ##        ##  ###   ## ##
##     ## ##     ## ##          ##    ##        ##  ####  ## ##
##     ## ##     ## ##          ##    ##        ##  ## ## ## ######
##     ## ##     ## ##          ##    ##        ##  ##  #### ##
##     ## ##     ## ##    ##    ##    ##        ##  ##   ### ##
########   #######   ######     ##    ######## #### ##    ## ########

 */
    if( (c.type == CALCULATION_TYPE_DUCT) && r.sectionResults.length > 1) {
      if (c.sections[0].type == CALCULATION_TYPE_CIRCULAR_DUCT) {
        spacerInputs = [
          {name: ui['SPACER_4'], id: '0.01'},
          {name: ui['SPACER_5'], id: '0.004'},
          {name: ui['SPACER_6'], id: '0.003'},
        ];
      }
      if (c.sections[0].type === CALCULATION_TYPE_RECTANGULAR_DUCT) {
        spacerInputs = [
          {name: ui['SPACER_1'], id: '0.0035'},
          {name: ui['SPACER_2'], id: '0.006'},
          {name: ui['SPACER_3'], id: '0.0085'},
        ];
      }

      const content = ( (typeof r.sectionResults[0].content === 'string') ? r.sectionResults[0].content : ( (r.sectionResults[0].content[printLanguage] !== false) ? r.sectionResults[0].content[printLanguage] : r.sectionResults[0].content['English']) );
      let contentPart = {title: ui['CONTENT-TITLE'], items: [
          {title: ui['PDF-TYPE'], value: content},
          {title: ui['CONTENT-TEMPERATURE'], value: (numeral(c.sections[0].temperature).format('0.0')).toString() + ' °C'},
        ]};
      let calcContentPart = createTableTwoCols(contentPart);

      let energyPart = [];
      let calcEnergyPart = [];
      if(c.calculateEnergyConsumption) {
        const energy = ( (typeof r.sectionResults[0].energySource === 'string') ? r.sectionResults[0].energySource : ( (r.sectionResults[0].energySource[printLanguage] !== false) ? r.sectionResults[0].energySource[printLanguage] : r.sectionResults[0].energySource['English']) );
        energyPart = {title: ui['ENERGY-TITLE'], items: [
            {title: ui['ENERGY-ENERGY_SOURCE'], value: energy},
            {title: ui['ENERGY-OPERATING_TIME'], value: (c.energyOperationTime).toString() + ' h'},
            {title: ui['ENERGY-PRICE_OF_ENERGY'], value: (c.energyPrice).toString() + ' ' + ui['COSTS-CURRENCY']},
          ]};
         calcEnergyPart = createTableTwoCols(energyPart);
      }

      let resultsPart = {items: [
        {title: ui['RESULT-HEAT_LOSS'], value: formatW(numeral(r.totalPipelineHeatLoss).format('0.0'))},
        {title: ui['RESULT-UNINSTALLED_HEAT_LOSS'], value: formatW(numeral(r.totalUninsulatedPipelineHeatLoss).format('0.0'))},
        {title: ui['RESULT-FINAL_TEMP_OF_CONTENTS'], value: (numeral(r.finalPipelineTemperature).format('0.0')).toString() + ' °C'}
        ]};

/*      if(r.totalAdaptersHeatLoss!==null) {
        resultsPart.items.push({title: ui['RESULT-TOTAL_ADAPTERS_HEATLOSS'], value:formatW(numeral(r.totalAdaptersHeatloss).format('0.0')) });
        resultsPart.items.push({title: ui['RESULT-TOTAL_HEATLOSS_WITH_ADAPTERS'], value:formatW(numeral(r.totalAdaptersHeatloss + r.totalPipelineHeatLoss).format('0.0')) });
      }
*/
      if(c.calculateEnergyConsumption) {
        resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS'], value: (numeral(r.totalAnnualSavingsKwh).format('0.0')).toString() + ' kWh, ' + (numeral(r.totalAnnualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
        resultsPart.items.push({title: ui['RESULT-CO2_EMISSIONS'], value: (numeral(r.totalCoEmissionReduction).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CO2']});
      }

      let calcResultsPart = createTableTwoCols(resultsPart);


      let objectTitle = createPartTitle(c.name + ' : ' + ui['CALCULATION-DUCT']);

      let resultsTitle = createPartTitle(ui['RESULT-RESULTS_FOR_DUCTLINE']);

      let columnObjectInfo = {columns: [objectTitle.concat(calcContentPart, calcEnergyPart), resultsTitle.concat(calcResultsPart)], columnGap: 10};

      calculationsPrintOut.push(columnObjectInfo);
      calculationsPrintOut.push({text: '', pageBreak: 'after'});

      for(let j = 0; j < r.sectionResults.length; j++) {
        calculationWarningsIndex = 0;
        calculationWarnings = [];

        let ductType;
        if(c.sections[j].type == CALCULATION_TYPE_RECTANGULAR_DUCT) {
          ductType = ui['CALCULATION-RECTANGULAR_DUCT'];
        } else {
          ductType = ui['CALCULATION-CIRCULAR_DUCT'];
        }

        calculationWarningsIndicator = '';
        if(r.sectionResults[j].warnings && r.sectionResults[j].warnings.object.length > 0) {
          for(let w = 0; w < r.sectionResults[j].warnings.object.length; w++) {
            calculationWarnings.push(r.sectionResults[j].warnings.object[w]);
            calculationWarningsIndex++;
            calculationWarningsIndicator += calculationWarningsIndex + ') ';
          }
        }
        const material = ( (typeof r.sectionResults[j].material === 'string') ? r.sectionResults[j].material : ( (r.sectionResults[j].material[printLanguage] !== false) ? r.sectionResults[j].material[printLanguage] : r.sectionResults[j].material['English']) );
        let objectPart = {items: [
            {title: ui['CALCULATION-SELECT_DUCT_TYPE'], value: ductType},
            {title: ui['PDF-MATERIAL'], value: material, warnings: calculationWarningsIndicator},
            {title: ui['SETTINGS-THICKNESS'], value: c.sections[j].thickness + ' mm'}
          ]};
        if(c.calculateEnergyConsumption || c.calculateFreezing || c.calculateTemperatureChange || c.calculateEndTemperature ) {
          objectPart.items.push({title: ui['CONTENT-FLOW_VELOCITY'], value: (c.sections[j].flowRate).toString() + ' ' + c.flowRateType});
          objectPart.items.push({title: ui['GENERAL-LENGHT'], value: (c.sections[j].length).toString() + ' m'});
          if(c.sections[j].type == CALCULATION_TYPE_RECTANGULAR_DUCT ) {
            objectPart.items.push({title: ui['GENERAL-WIDTH'], value: (numeral(c.sections[j].width).format('0')).toString() + ' mm'});
            objectPart.items.push({title: ui['GENERAL-HEIGHT'], value: (numeral(c.sections[j].height).format('0')).toString() + ' mm'});
          } else {
            objectPart.items.push({title: ui['GENERAL-OUTER_DIAMETER'], value: (numeral(c.sections[j].outerDiameter).format('0')).toString() + ' mm'});
          }
        }
        let calcObjectPart = createTableTwoCols(objectPart);

        let environmentPart = {title: ui['ENVIRONMENT-TITLE'], items: [
            {title: ui['ENVIRONMENT-AMBIENT_TEMPERATURE'], value: (c.sections[j].environmentTemperature).toString() + ' °C'},
            {title: ui['ENVIRONMENT-AMBIENT_AIR_VELOCITY'], value: (c.sections[j].environmentAirVelocity).toString() + ' m/s'},
            {title: ui['ENVIRONMENT-RELATIVE_HUMIDITY'], value: (c.sections[j].environmentHumidity).toString() + ' %'}
          ]};
        let calcEnvironmentPart = createTableTwoCols(environmentPart);

        let insulations = [];
        if(c.sections[j].noInsulation) {
          insulations.push({title: ui['GENERAL-NO_INSULATION'], detail: '', value: ''});
        } else {
          for(let k = 0; k < r.sectionResults[j].layers.length; k++) {
            calculationWarningsIndicator = '';
            if(r.sectionResults[j].layers[k].warnings.length > 0) {
              for(let w = 0; w < r.sectionResults[j].layers[k].warnings.length; w++) {
                calculationWarnings.push(r.sectionResults[j].layers[k].warnings[w]);
                calculationWarningsIndex++;
                calculationWarningsIndicator += ' ' + calculationWarningsIndex + ')';
              }
            }
            insulations.push({
              title: r.sectionResults[j].layers[k].product.name,
              detail: (r.sectionResults[j].layers[k].product.thickness).toString() + ' mm',
              value: (numeral(r.sectionResults[j].layers[k].surfaceTemperature).format('0.0')).toString() + ' °C',
              warnings: calculationWarningsIndicator
            });
          }
        }
        let insulationPart = {
          title: ui['PDF-INSULATIONS'], items: insulations
        };
        let calcInsulationPart =  createTableThreeCols(insulationPart);

        let claddingPart = {};
        if(c.sections[j].noInsulation) {
          claddingPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: ui['GENERAL-NO_CLADDING'], value: ''},
          ]};
        } else {
          if(r.sectionResults[j].warnings && r.sectionResults[j].warnings.surface.length > 0) {
            for(let w = 0; w < r.sectionResults[j].warnings.surface.length; w++) {
              calculationWarnings.push(r.sectionResults[j].warnings.surface[w]);
              calculationWarningsIndex++;
              calculationWarningsIndicator += calculationWarningsIndex + ') ';
            }
          }
          const cladding = ( (typeof r.sectionResults[j].cladding === 'string') ? r.sectionResults[j].cladding : ( (r.sectionResults[j].cladding[printLanguage] !== false) ? r.sectionResults[j].cladding[printLanguage] : r.sectionResults[j].cladding['English']) );
          claddingPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: cladding, value: ui['INSULATION-EMISSITIVITY'] + ': ' + (c.sections[j].emissivity).toString(), warnings: calculationWarningsIndicator},
          ]
          };

          if(c.sections[j].suspensionOfTarget) {
            claddingPart.items.push({title: ui['PDF-SUSPENSION_ADDITION'], value: (numeral(c.sections[j].suspensionInfluence).format('0.0')).toString() + ' %'});
          }

          if (c.sections[j].supportOfCladding) {
            const type = spacerInputs.find(item => item.id === c.sections[j].influenceOnHeatloss).name || 'not found';
            if (c.sections[j].type == CALCULATION_TYPE_CIRCULAR_DUCT) {
              claddingPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}` });
            } else {
              claddingPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}, ${(numeral(c.sections[j].spacersPerM).format('0')).toString()} / m²` });
            }
          }

          if (c.sections[j].mechanicalFastener) {
            const type = mechanicalFastenersInputs.find(item => item.id === c.sections[j].mechanicalInfluence).name || 'not found';
            claddingPart.items.push({ title: ui['GENERAL_MECH_FASTENER'], value: `${type}, ${(numeral(c.sections[j].mechanicalPerM).format('0')).toString()} / m²` });
          }
        }
        let calcCladdingPart = createTableTwoCols(claddingPart);

        let resultsPart = {items: [
          {title: ui['RESULT-HEAT_LOSS'], value: formatWperLength(numeral(r.sectionResults[j].heatloss).format('0.0'))},
          {title: ui['PDF-SECTION_TOTAL_HEAT_LOSS'], value: formatW(numeral(r.sectionResults[j].totalSectionHeatloss).format('0.0'))},
          {title: ui['RESULT-UNINSTALLED_HEAT_LOSS'], value: formatWperLength(numeral(r.sectionResults[j].uninsulatedHeatLoss).format('0.0'))},
          ]};

        if(app.country === 'Denmark' || app.country === 'Sweden' || (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) {
          resultsPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[j].uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[j].uKlasseUnit});
          resultsPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[j].klasse + 1) + ')' ), value: (numeral(r.sectionResults[j].uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[j].uKlasseUnit});
        }

        // if(c.sections[j].supportOfCladding) {
        //   resultsPart.items.push({title: ui['PDF-SUPPORT_ADDITION'], value:(numeral(c.sections[j].influenceOnHeatloss).format('0.0')).toString()+' %'});
        // }

        // if(c.sections[j].suspensionOfTarget) {
        //   resultsPart.items.push({title: ui['PDF-SUSPENSION_ADDITION'], value:(numeral(c.sections[j].suspensionInfluence).format('0.0')).toString()+' %'});
        // }

        if(c.sections[j].calculateAdapters) {
          resultsPart.items.push({title: ui['RESULT-ADAPTERS_HEATLOSS'], value: formatW(numeral(r.sectionResults[j].adapterHeatlossTotal).format('0.0')) });
          resultsPart.items.push({title: ui['RESULT-HEATLOSS_WITH_ADAPTERS'], value: formatW(numeral(r.sectionResults[j].adapterHeatlossTotal + r.sectionResults[j].totalSectionHeatloss).format('0.0')) });
        }


        resultsPart.items.push({title: ui['RESULT-SURFACE_TEMPERATURE'], value: (numeral(r.sectionResults[j].surfaceTemperature).format('0.0')).toString() + ' °C'});
        resultsPart.items.push({title: ui['RESULT-UNINSULATED_SURFACE_TEMPERATURE'], value: (numeral(r.sectionResults[j].uninsulatedSurfaceTemperature).format('0.0')).toString() + ' °C'});
        resultsPart.items.push({title: ui['RESULT-DEW_POINT'], value: (numeral(r.sectionResults[j].dewPoint).format('0.0')).toString() + ' °C'});
        resultsPart.items.push({title: ui['RESULT-TEMPERATURE_CHANGE'], value: (numeral(r.sectionResults[j].temperatureDrop).format('0.0')).toString() + ' °C'});
        if(c.sections[j].noInsulation !== true) {
          resultsPart.items.push({title: ui['RESULT-NOMINAL_WEIGHT'], value: (numeral(r.sectionResults[j].nominalWeight).format('0.0')).toString() + ' kg/m'});
        }

        if(c.calculateEnergyConsumption) {
          resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS'], value: (numeral(r.sectionResults[j].annualSavingsKwh).format('0.0')).toString() + ' kWh, ' + (numeral(r.sectionResults[j].annualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
          resultsPart.items.push({title: ui['RESULT-CO2_EMISSIONS'], value: (numeral(r.sectionResults[j].coEmissionReduction).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CO2']});
        }


        let calcResultsPart = createTableTwoCols(resultsPart);

        let sectionTitle = createPartTitle(ui['CALCULATION-RECTANGULAR_DUCT'] + ' : ' + ui['PDF-SECTION'] + ' ' + (j + 1).toString());
        if(c.sections[j].type == CALCULATION_TYPE_CIRCULAR_DUCT) {
          sectionTitle = createPartTitle(ui['CALCULATION-CIRCULAR_DUCT'] + ' : ' + ui['PDF-SECTION'] + ' ' + (j + 1).toString());
        }

        let sectionResultsTitle = createPartTitle(ui['PDF-RESULTS']);

        let columnObjectInfo = {columns: [sectionTitle.concat(calcObjectPart, calcEnvironmentPart, calcInsulationPart, calcCladdingPart), sectionResultsTitle.concat(calcResultsPart)], columnGap: 10};

        if(calculationWarningsIndex > 0) {
          let warningsPart = [];
          for(let w = 0; w < calculationWarnings.length; w++) {
            warningsPart.push({title: (w + 1).toString() + ')', value: calculationWarnings[w]});
          }
          let calcWarningsPart = createWarningsTable(warningsPart);
          let warningsTitle = [];
          if (printProjects) {
            warningsTitle.push({text: '', pageBreak: 'after'});
          }
          warningsTitle.push(createPartTitle(ui['PDF-WARNINGS']));

          calculationsPrintOut.push(columnObjectInfo, warningsTitle, calcWarningsPart);
        } else {
          calculationsPrintOut.push(columnObjectInfo);
        }

        if(j < r.sectionResults.length - 1) {
          calculationsPrintOut.push({text: '', pageBreak: 'after'});
        }
      }
    }

// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
// ////////////////////////////////////////////////////////////////////////////////////////
/*

########    ###    ##    ## ##    ##  ######
   ##      ## ##   ###   ## ##   ##  ##    ##
   ##     ##   ##  ####  ## ##  ##   ##
   ##    ##     ## ## ## ## #####     ######
   ##    ######### ##  #### ##  ##         ##
   ##    ##     ## ##   ### ##   ##  ##    ##
   ##    ##     ## ##    ## ##    ##  ######

 */
    if (c.type == CALCULATION_TYPE_RECTANGULAR_TANK || c.type == CALCULATION_TYPE_HORIZONTAL_TANK || c.type == CALCULATION_TYPE_VERTICAL_TANK) {
      spacerInputs = [
        {name: ui['SPACER_1'], id: '0.0035'},
        {name: ui['SPACER_2'], id: '0.006'},
        {name: ui['SPACER_3'], id: '0.0085'},
      ];

      if(r.sectionResults[0].warnings && r.sectionResults[0].warnings.object.length > 0) {
        for(let w = 0; w < r.sectionResults[0].warnings.object.length; w++) {
          calculationWarnings.push(r.sectionResults[0].warnings.object[w]);
          calculationWarningsIndex++;
          calculationWarningsIndicator += calculationWarningsIndex + ') ';
        }
      }
      const material = ( (typeof r.sectionResults[0].material === 'string') ? r.sectionResults[0].material : ( (r.sectionResults[0].material[printLanguage] !== false) ? r.sectionResults[0].material[printLanguage] : r.sectionResults[0].material['English']) );
      let objectPart = {title: ui['PDF-TARGET'], items: [
          {title: ui['PDF-MATERIAL'], value: material, warnings: calculationWarningsIndicator},
          {title: ui['SETTINGS-THICKNESS'], value: (c.sections[0].thickness).toString() + ' mm'},
        ]};
      if (c.type == CALCULATION_TYPE_RECTANGULAR_TANK) {
        objectPart.items.push({title: ui['GENERAL-LENGHT'], value: (c.sections[0].length).toString() + ' mm'});
        objectPart.items.push({title: ui['GENERAL-HEIGHT'], value: (c.sections[0].height).toString() + ' mm'});
        objectPart.items.push({title: ui['GENERAL-WIDTH'], value: (c.sections[0].width).toString() + ' mm'});
      }
      if(c.type == CALCULATION_TYPE_HORIZONTAL_TANK) {
        objectPart.items.push({title: ui['TANK-ORIENTATION'], value: ui['TANK-LANDSCAPE']});
        objectPart.items.push({title: ui['GENERAL-OUTER_DIAMETER'], value: (c.sections[0].outerDiameter).toString() + ' mm'});
        objectPart.items.push({title: ui['GENERAL-LENGHT'], value: (c.sections[0].length).toString() + ' mm'});
      }
      if(c.type == CALCULATION_TYPE_VERTICAL_TANK) {
        objectPart.items.push({title: ui['TANK-ORIENTATION'], value: ui['TANK-PORTRAIT']});
        objectPart.items.push({title: ui['GENERAL-OUTER_DIAMETER'], value: (c.sections[0].outerDiameter).toString() + ' mm'});
        objectPart.items.push({title: ui['GENERAL-HEIGHT'], value: (c.sections[0].height).toString() + ' mm'});
      }
      (c.type !== CALCULATION_TYPE_HORIZONTAL_TANK) && objectPart.items.push({
        title: ui['GENERAL_BASE_OF_TANK'],
        value: (c.sections[0].tankBase === 'concrete' ? ui['TARGET_CONCRETE_PLAIN'] : (c.sections[0].tankBase === 'ground' ? ui['TARGET_GROUND_PLAIN'] : ui['TARGET_LEGS_PLAIN']))
      });

      let calcObjectPart = createTableTwoCols(objectPart);

      let calcInsulationPart = [];
      if(c.type == CALCULATION_TYPE_HORIZONTAL_TANK) {
        calculationWarningsIndicator = '';
        let insulations = [];
        if(c.sections[0].topNoInsulation) {
          insulations.push({title: ui['GENERAL-NO_INSULATION'], detail: '', value: ''});
        } else {
          for(let j = 0; j < r.sectionResults[0].topLayers.layers.length; j++) {
            calculationWarningsIndicator = '';
            if(r.sectionResults[0].topLayers.layers[j].warnings.length > 0) {
              for(let w = 0; w < r.sectionResults[0].topLayers.layers[j].warnings.length; w++) {
                calculationWarnings.push(r.sectionResults[0].topLayers.layers[j].warnings[w]);
                calculationWarningsIndex++;
                calculationWarningsIndicator += ' ' + calculationWarningsIndex + ')';
              }
            }
            insulations.push({
              title: r.sectionResults[0].topLayers.layers[j].product.name,
              detail: (r.sectionResults[0].topLayers.layers[j].product.thickness).toString() + ' mm',
              value: (numeral(r.sectionResults[0].topLayers.layers[j].surfaceTemperature).format('0.0')).toString() + ' °C',
              warnings: calculationWarningsIndicator
            });
          }

          insulations.push({
            title: ui['RESULT-NOMINAL_WEIGHT'],
            detail: '',
            value: (numeral(r.sectionResults[0].topLayers.nominalWeight).format('0.0')).toString() + ' kg/m²',
            warnings: ''
          });
        }
        let insulationPart = {
          title: ui['PDF-INSULATIONS'], items: insulations
        };
        let calcSideInsulationPart =  createTableThreeCols(insulationPart);

        calculationWarningsIndicator = '';
        if(r.sectionResults[0].topLayers.warnings && r.sectionResults[0].topLayers.warnings.surface && r.sectionResults[0].topLayers.warnings.surface.length > 0) {
          for(let w = 0; w < r.sectionResults[0].topLayers.warnings.surface.length; w++) {
            calculationWarnings.push(r.sectionResults[0].topLayers.warnings.surface[w]);
            calculationWarningsIndex++;
            calculationWarningsIndicator += calculationWarningsIndex + ') ';
          }
        }

        let claddingPart = {};
        if(c.sections[0].topNoInsulation) {
          claddingPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: ui['GENERAL-NO_CLADDING'], value: '', warnings: calculationWarningsIndicator},
          ]};
        } else {
          const cladding = ( (typeof r.sectionResults[0].topLayers.cladding === 'string') ? r.sectionResults[0].topLayers.cladding : ( (r.sectionResults[0].topLayers.cladding[printLanguage] !== false) ? r.sectionResults[0].topLayers.cladding[printLanguage] : r.sectionResults[0].topLayers.cladding['English']) );
          claddingPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: cladding, value: ui['INSULATION-EMISSITIVITY'] + ': ' + (c.sections[0].emissivity).toString(), warnings: calculationWarningsIndicator},
          ]};

          if(app.country === 'Denmark' || ( app.country !== 'Sweden' && (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) ) {
            claddingPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].topLayers.uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].topLayers.uKlasseUnit});
            claddingPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].topLayers.uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].topLayers.uKlasseUnit});
          }

          if(app.country === 'Sweden') {
            claddingPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].topLayers.uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].topLayers.uKlasseUnit});
            claddingPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE-PIPE-SWEDEN'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].topLayers.uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].topLayers.uKlasseUnit});
          }
          if (c.sections[0].supportOfCladding) {
            const type = spacerInputs.find(item => {
              return item.id === c.sections[0].influenceOnHeatloss;
            }).name || 'not found';
            claddingPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}, ${(numeral(c.sections[0].spacersPerM).format('0')).toString()} / m²` });
          }

          if (c.sections[0].mechanicalFastener) {
            const type = mechanicalFastenersInputs.find(item => item.id === c.sections[0].mechanicalInfluence).name || 'not found';
            claddingPart.items.push({ title: ui['GENERAL_MECH_FASTENER'], value: `${type}, ${(numeral(c.sections[0].mechanicalPerM).format('0')).toString()} / m²` });
          }
        }
        let calcCladdingPart = createTableTwoCols(claddingPart);

        calcInsulationPart = calcSideInsulationPart.concat(calcCladdingPart);
      } else {
        calculationWarningsIndicator = '';
        let topInsulations = [];
        if(c.sections[0].topNoInsulation) {
          topInsulations.push({title: ui['GENERAL-NO_INSULATION'], detail: '', value: ''});
        } else {
          for(let j = 0; j < r.sectionResults[0].topLayers.layers.length; j++) {
            calculationWarningsIndicator = '';
            if(r.sectionResults[0].topLayers.layers[j].warnings.length > 0) {
              for(let w = 0; w < r.sectionResults[0].topLayers.layers[j].warnings.length; w++) {
                calculationWarnings.push(r.sectionResults[0].topLayers.layers[j].warnings[w]);
                calculationWarningsIndex++;
                calculationWarningsIndicator += ' ' + calculationWarningsIndex + ')';
              }
            }
            topInsulations.push({
              title: r.sectionResults[0].topLayers.layers[j].product.name,
              detail: (r.sectionResults[0].topLayers.layers[j].product.thickness).toString() + ' mm',
              value: (numeral(r.sectionResults[0].topLayers.layers[j].surfaceTemperature).format('0.0')).toString() + ' °C',
              warnings: calculationWarningsIndicator
            });
          }
          topInsulations.push({
            title: ui['RESULT-HEAT_LOSS'],
            detail: '',
            value: formatWperArea(numeral(r.sectionResults[0].topLayers.heatloss).format('0.0')),
            warnings: ''
          });

          topInsulations.push({
            title: ui['RESULT-NOMINAL_WEIGHT'],
            detail: '',
            value: (numeral(r.sectionResults[0].topLayers.nominalWeight).format('0.0')).toString() + ' kg/m²',
            warnings: ''
          });
        }
        let topInsulationPart = {
          title: ui['PDF-TOP_INSULATION'], items: topInsulations
        };

        let calcTopInsulationPart =  createTableThreeCols(topInsulationPart);

        calculationWarningsIndicator = '';
        if(r.sectionResults[0].topLayers.warnings && r.sectionResults[0].topLayers.warnings.surface.length > 0) {
          for(let w = 0; w < r.sectionResults[0].topLayers.warnings.surface.length; w++) {
            calculationWarnings.push(r.sectionResults[0].topLayers.warnings.surface[w]);
            calculationWarningsIndex++;
            calculationWarningsIndicator += calculationWarningsIndex + ') ';
          }
        }
        let claddingTopPart = {};
        if(c.sections[0].topNoInsulation) {
          claddingTopPart = {items: [
            {title: ui['GENERAL-NO_CLADDING'], value: '', warnings: calculationWarningsIndicator},
          ]};
        } else {
          const claddingTop = ( (typeof r.sectionResults[0].topLayers.cladding === 'string') ? r.sectionResults[0].topLayers.cladding : ( (r.sectionResults[0].topLayers.cladding[printLanguage] !== false) ? r.sectionResults[0].topLayers.cladding[printLanguage] : r.sectionResults[0].topLayers.cladding['English']) );
          claddingTopPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: claddingTop, value: ui['INSULATION-EMISSITIVITY'] + ': ' + (c.sections[0].topEmissivity).toString(), warnings: calculationWarningsIndicator},
          ]};

          // if(c.sections[0].sideValues.top.supportOfCladding) {
          //   claddingTopPart.items.push({title: ui['PDF-SUPPORT_ADDITION'], value:(numeral(c.sections[0].sideValues.top.influenceOnHeatloss).format('0.0')).toString()+' %'})
          // }

          if(app.country === 'Denmark' || ( app.country !== 'Sweden' && (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) ) {
            claddingTopPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].topLayers.uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].topLayers.uKlasseUnit});
            claddingTopPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].topLayers.uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].topLayers.uKlasseUnit});
          }

          if(app.country === 'Sweden') {
            claddingTopPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].topLayers.uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].topLayers.uKlasseUnit});
            claddingTopPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE-PIPE-SWEDEN'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].topLayers.uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].topLayers.uKlasseUnit});
          }

          if (c.sections[0].sideValues.top.supportOfCladding) {
            const type = spacerInputs.find(item => item.id === c.sections[0].sideValues.top.influenceOnHeatloss).name || 'not found';
            claddingTopPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}, ${(numeral(c.sections[0].sideValues.top.spacersPerM).format('0')).toString()} / m²` });
          }

          if (c.sections[0].sideValues.top.mechanicalFastener) {
            const type = mechanicalFastenersInputs.find(item => item.id === c.sections[0].sideValues.top.mechanicalInfluence).name || 'not found';
            claddingTopPart.items.push({ title: ui['GENERAL_MECH_FASTENER'], value: `${type}, ${(numeral(c.sections[0].sideValues.top.mechanicalPerM).format('0')).toString()} / m²` });
          }
        }
        let calcCladdingTopPart = createTableTwoCols(claddingTopPart);


        calculationWarningsIndicator = '';
        let sideInsulations = [];
        if(c.sections[0].sideNoInsulation) {
          sideInsulations.push({title: ui['GENERAL-NO_INSULATION'], detail: '', value: ''});
        } else {
          for(let j = 0; j < r.sectionResults[0].sideLayers.layers.length; j++) {
            calculationWarningsIndicator = '';
            if(r.sectionResults[0].sideLayers.layers[j].warnings.length > 0) {
              for(let w = 0; w < r.sectionResults[0].sideLayers.layers[j].warnings.length; w++) {
                calculationWarnings.push(r.sectionResults[0].sideLayers.layers[j].warnings[w]);
                calculationWarningsIndex++;
                calculationWarningsIndicator += ' ' + calculationWarningsIndex + ')';
              }
            }
            sideInsulations.push({
              title: r.sectionResults[0].sideLayers.layers[j].product.name,
              detail: (r.sectionResults[0].sideLayers.layers[j].product.thickness).toString() + ' mm',
              value: (numeral(r.sectionResults[0].sideLayers.layers[j].surfaceTemperature).format('0.0')).toString() + ' °C',
              warnings: calculationWarningsIndicator
            });
          }
          sideInsulations.push({
            title: ui['RESULT-HEAT_LOSS'],
            detail: '',
            value: formatWperArea(numeral(r.sectionResults[0].sideLayers.heatloss).format('0.0')),
            warnings: ''
          });
          sideInsulations.push({
            title: ui['RESULT-NOMINAL_WEIGHT'],
            detail: '',
            value: (numeral(r.sectionResults[0].sideLayers.nominalWeight).format('0.0')).toString() + ' kg/m²',
            warnings: ''
          });
        }
        let sideInsulationPart = {
          title: ui['PDF-SIDE_INSULATION'], items: sideInsulations
        };

        let calcSideInsulationPart =  createTableThreeCols(sideInsulationPart);

        calculationWarningsIndicator = '';
        if(r.sectionResults[0].sideLayers.warnings && r.sectionResults[0].sideLayers.warnings.surface.length > 0) {
          for(let w = 0; w < r.sectionResults[0].sideLayers.warnings.surface.length; w++) {
            calculationWarnings.push(r.sectionResults[0].sideLayers.warnings.surface[w]);
            calculationWarningsIndex++;
            calculationWarningsIndicator += calculationWarningsIndex + ') ';
          }
        }
        let claddingSidePart = {};
        if(c.sections[0].sideNoInsulation) {
          claddingSidePart = {items: [
            {title: ui['GENERAL-NO_CLADDING'], value: '', warnings: calculationWarningsIndicator},
          ]};
        } else {
          const claddingSide = ( (typeof r.sectionResults[0].sideLayers.cladding === 'string') ? r.sectionResults[0].sideLayers.cladding : ( (r.sectionResults[0].sideLayers.cladding[printLanguage] !== false) ? r.sectionResults[0].sideLayers.cladding[printLanguage] : r.sectionResults[0].sideLayers.cladding['English']) );
          claddingSidePart = {title: ui['INSULATION-CLADDING'], items: [
            {title: claddingSide, value: ui['INSULATION-EMISSITIVITY'] + ': ' + (c.sections[0].sideEmissivity).toString(), warnings: calculationWarningsIndicator},
          ]};

          // if(c.sections[0].sideValues.side.supportOfCladding) {
          //   claddingSidePart.items.push({title: ui['PDF-SUPPORT_ADDITION'], value:(numeral(c.sections[0].sideValues.side.influenceOnHeatloss).format('0.0')).toString()+' %'})
          // }

          if(app.country === 'Denmark' || ( app.country !== 'Sweden' && (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) ) {
            claddingSidePart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].sideLayers.uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].sideLayers.uKlasseUnit});
            claddingSidePart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].sideLayers.uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].sideLayers.uKlasseUnit});
          }

          if( app.country === 'Sweden' ) {
            claddingSidePart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].sideLayers.uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].sideLayers.uKlasseUnit});
            claddingSidePart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE-PIPE-SWEDEN'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].sideLayers.uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].sideLayers.uKlasseUnit});
          }

          if (c.sections[0].sideValues.side.supportOfCladding) {
            const type = spacerInputs.find(item => item.id === c.sections[0].sideValues.side.influenceOnHeatloss).name || 'not found';
            claddingSidePart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}, ${(numeral(c.sections[0].sideValues.side.spacersPerM).format('0')).toString()} / m²` });
          }

          if (c.sections[0].sideValues.side.mechanicalFastener) {
            const type = mechanicalFastenersInputs.find(item => item.id === c.sections[0].sideValues.side.mechanicalInfluence).name || 'not found';
            claddingSidePart.items.push({ title: ui['GENERAL_MECH_FASTENER'], value: `${type}, ${(numeral(c.sections[0].sideValues.side.mechanicalPerM).format('0')).toString()} / m²` });
          }
        }
        let calcCladdingSidePart = createTableTwoCols(claddingSidePart);


        calculationWarningsIndicator = '';
        let bottomInsulations = [];
        if(c.sections[0].bottomNoInsulation) {
          bottomInsulations.push({title: ui['GENERAL-NO_INSULATION'], detail: '', value: ''});
        } else {
          for(let j = 0; j < r.sectionResults[0].bottomLayers.layers.length; j++) {
            calculationWarningsIndicator = '';
            if(r.sectionResults[0].bottomLayers.layers[j].warnings.length > 0) {
              for(let w = 0; w < r.sectionResults[0].bottomLayers.layers[j].warnings.length; w++) {
                calculationWarnings.push(r.sectionResults[0].bottomLayers.layers[j].warnings[w]);
                calculationWarningsIndex++;
                calculationWarningsIndicator += ' ' + calculationWarningsIndex + ')';
              }
            }
            bottomInsulations.push({
              title: r.sectionResults[0].bottomLayers.layers[j].product.name,
              detail: (r.sectionResults[0].bottomLayers.layers[j].product.thickness).toString() + ' mm',
              value: (numeral(r.sectionResults[0].bottomLayers.layers[j].surfaceTemperature).format('0.0')).toString() + ' °C',
              warnings: calculationWarningsIndicator
            });
          }
          bottomInsulations.push({
            title: ui['RESULT-HEAT_LOSS'],
            detail: '',
            value: formatWperArea(numeral(r.sectionResults[0].bottomLayers.heatloss).format('0.0')),
            warnings: ''
          });
          bottomInsulations.push({
            title: ui['RESULT-NOMINAL_WEIGHT'],
            detail: '',
            value: (numeral(r.sectionResults[0].bottomLayers.nominalWeight).format('0.0')).toString() + ' kg/m²',
            warnings: ''
          });
        }
        let bottomInsulationPart = {
          title: ui['PDF-BOTTOM_INSULATION'], items: bottomInsulations
        };

        let calcBottomInsulationPart =  createTableThreeCols(bottomInsulationPart);

        calculationWarningsIndicator = '';
        if(r.sectionResults[0].bottomLayers.warnings && r.sectionResults[0].bottomLayers.warnings.surface.length > 0) {
          for(let w = 0; w < r.sectionResults[0].bottomLayers.warnings.surface.length; w++) {
            calculationWarnings.push(r.sectionResults[0].bottomLayers.warnings.surface[w]);
            calculationWarningsIndex++;
            calculationWarningsIndicator += calculationWarningsIndex + ') ';
          }
        }
        let claddingBottomPart = {};
        if(c.sections[0].bottomNoInsulation) {
          claddingBottomPart = {items: [
            {title: ui['GENERAL-NO_CLADDING'], value: '', warnings: calculationWarningsIndicator},
          ]};
        } else {
          const claddingBottom = ( (typeof r.sectionResults[0].bottomLayers.cladding === 'string') ? r.sectionResults[0].bottomLayers.cladding : ( (r.sectionResults[0].bottomLayers.cladding[printLanguage] !== false) ? r.sectionResults[0].bottomLayers.cladding[printLanguage] : r.sectionResults[0].bottomLayers.cladding['English']) );
          claddingBottomPart = {title: ui['INSULATION-CLADDING'], items: [
            {title: claddingBottom, value: ui['INSULATION-EMISSITIVITY'] + ': ' + (c.sections[0].bottomEmissivity).toString(), warnings: calculationWarningsIndicator},
          ]};

          // if(c.sections[0].sideValues.bottom.supportOfCladding) {
          //   claddingBottomPart.items.push({title: ui['PDF-SUPPORT_ADDITION'], value:(numeral(c.sections[0].sideValues.bottom.influenceOnHeatloss).format('0.0')).toString()+' %'})
          // }

          if(app.country === 'Denmark' || ( app.country !== 'Sweden' && (settings.data[0]['countries-using-classes'].indexOf(app.country) !== -1)) ) {
            claddingBottomPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].bottomLayers.uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].bottomLayers.uKlasseUnit});
            claddingBottomPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].bottomLayers.uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].bottomLayers.uKlasseUnit});
          }

          if( app.country === 'Sweden' ) {
            claddingBottomPart.items.push({title: ui['CALCULATION-TARGET-UVALUE'], value: (numeral(r.sectionResults[0].bottomLayers.uKlasse).format('0.00')).toString() + ' ' + r.sectionResults[0].bottomLayers.uKlasseUnit});
            claddingBottomPart.items.push({title: (ui['CALCULATION-TARGET-KLASSE-UVALUE'] + ' (' + ui['CALCULATION-TARGET-KLASSE-PIPE-SWEDEN'] + ' ' + (c.sections[0].klasse + 1) + ')' ), value: (numeral(r.sectionResults[0].bottomLayers.uKlasseNorm).format('0.00')).toString() + ' ' + r.sectionResults[0].bottomLayers.uKlasseUnit});
          }

          if (c.sections[0].sideValues.bottom.supportOfCladding) {
            const type = spacerInputs.find(item => item.id === c.sections[0].sideValues.bottom.influenceOnHeatloss).name || 'not found';
            claddingBottomPart.items.push({ title: ui['GENERAL_SPACERS'], value: `${type}, ${(numeral(c.sections[0].sideValues.bottom.spacersPerM).format('0')).toString()} per m²` });
          }

          if (c.sections[0].sideValues.bottom.mechanicalFastener) {
            const type = mechanicalFastenersInputs.find(item => item.id === c.sections[0].sideValues.bottom.mechanicalInfluence).name || 'not found';
            claddingBottomPart.items.push({ title: ui['GENERAL_MECH_FASTENER'], value: `${type}, ${(numeral(c.sections[0].sideValues.bottom.mechanicalPerM).format('0')).toString()} per m²` });
          }
        }
        let calcCladdingBottomPart = createTableTwoCols(claddingBottomPart);

        calcInsulationPart = calcTopInsulationPart.concat(calcCladdingTopPart, calcSideInsulationPart, calcCladdingSidePart, calcBottomInsulationPart, calcCladdingBottomPart);
      }

      const content = ( (typeof r.sectionResults[0].content === 'string') ? r.sectionResults[0].content : ( (r.sectionResults[0].content[printLanguage] !== false) ? r.sectionResults[0].content[printLanguage] : r.sectionResults[0].content['English']) );
      let contentPart = {title: ui['CONTENT-TITLE'], items: [
          {title: ui['PDF-TYPE'], value: content},
          {title: ui['CONTENT-TEMPERATURE'], value: (numeral(c.sections[0].temperature).format('0.0')).toString() + ' °C'},
        ]};
      if(c.calculateEndTemperature) {
        contentPart.items.push({title: ui['CONTENT-THRESHOLD_TEMPERATURE'], value: (numeral(c.sections[0].finalTemperature).format('0.0')).toString() + ' °C'});
      }
      let calcContentPart = createTableTwoCols(contentPart);

      let environmentPart = {title: ui['ENVIRONMENT-TITLE'], items: [
          {title: ui['ENVIRONMENT-AMBIENT_TEMPERATURE'], value: (c.sections[0].environmentTemperature).toString() + ' °C'},
          {title: ui['ENVIRONMENT-AMBIENT_AIR_VELOCITY'], value: (c.sections[0].environmentAirVelocity).toString() + ' m/s'},
          {title: ui['ENVIRONMENT-RELATIVE_HUMIDITY'], value: (c.sections[0].environmentHumidity).toString() + ' %'}
        ]};
      let calcEnvironmentPart = createTableTwoCols(environmentPart);
      let energyPart = [];
      let calcEnergyPart = [];
      if(c.calculateEnergyConsumption) {
        const energy = ( (typeof r.sectionResults[0].energySource === 'string') ? r.sectionResults[0].energySource : ( (r.sectionResults[0].energySource[printLanguage] !== false) ? r.sectionResults[0].energySource[printLanguage] : r.sectionResults[0].energySource['English']) );
        energyPart = {title: ui['ENERGY-TITLE'], items: [
            {title: ui['ENERGY-ENERGY_SOURCE'], value: energy},
            {title: ui['ENERGY-OPERATING_TIME'], value: (c.energyOperationTime).toString() + ' h'},
            {title: ui['ENERGY-PRICE_OF_ENERGY'], value: (c.energyPrice).toString() + ' ' + ui['COSTS-CURRENCY']},
          ]};
         calcEnergyPart = createTableTwoCols(energyPart);
      }
      let columnObjectInfo;
      if(c.type == CALCULATION_TYPE_HORIZONTAL_TANK) {
        columnObjectInfo = {columns: [calcObjectPart.concat(calcInsulationPart), calcContentPart.concat(calcEnvironmentPart, calcEnergyPart)], columnGap: 10};
      } else {
        columnObjectInfo = {columns: [calcObjectPart.concat(calcContentPart, calcEnvironmentPart, calcEnergyPart), calcInsulationPart], columnGap: 10};
      }

      let resultsPart = {items: [
        {title: ui['RESULT-HEAT_LOSS'], value: formatWperArea(numeral(r.heatLossPerSqrM).format('0.0'))},
        {title: ui['RESULT-UNINSTALLED_HEAT_LOSS'], value: formatWperArea(numeral(r.unisulatedHeatLossPerSqrM).format('0.0'))},
        {title: ui['RESULT-TOTAL_HEAT_LOSS'], value: formatW(numeral(r.heatloss).format('0.0'))},
        {title: ui['RESULT-TOTAL_UNINSTALLED_HEAT_LOSS'], value: formatW(numeral(r.uninsulatedHeatLoss).format('0.0'))},
        {title: ui['RESULT-DEW_POINT'], value: (numeral(r.dewPoint).format('0.0')).toString() + ' °C'},
        ]};

      // if(c.sections[0].supportOfCladding) {
      //   resultsPart.items.push({title: ui['PDF-SUPPORT_ADDITION'], value:(numeral(c.sections[0].influenceOnHeatloss).format('0.0')).toString()+' %'});
      // }

      if(c.calculateEndTemperature) {
        resultsPart.items.push({title: ui['RESULT-COOLING_TIME'], value: (numeral(r.coolingTime).format('0.0')).toString() + ' h'});
      }

      if(c.calculateEnergyConsumption) {
        resultsPart.items.push({title: ui['RESULT-ANNUAL_SAVINGS'], value: (numeral(r.annualSavingsKwh).format('0.0')).toString() + ' kWh, ' + (numeral(r.annualSavings).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CURRENCY']});
        resultsPart.items.push({title: ui['RESULT-CO2_EMISSIONS'], value: (numeral(r.coEmissionReduction).format('0.0')).toString() + ' ' + ui['COSTS-RESULT_CO2']});
      }

      let calcResultsPart = createTableTwoCols(resultsPart);

      let objectTitle = [];
      if(c.type == CALCULATION_TYPE_RECTANGULAR_TANK) {
        objectTitle = createPartTitle(c.name + ' : ' + ui['CALCULATION-RECTANGULAR_TANK']);
      } else {
        objectTitle = createPartTitle(c.name + ' : ' + ui['CALCULATION-CIRCULAR_TANK']);
      }

      let resultsTitle = [];
      if(c.type == CALCULATION_TYPE_RECTANGULAR_TANK || c.type == CALCULATION_TYPE_VERTICAL_TANK ) {
        resultsTitle.push({text: '', pageBreak: 'before'});
      }
      resultsTitle.push(createPartTitle(ui['PDF-RESULTS']));

      if(calculationWarningsIndex > 0) {
        let warningsPart = [];
        for(let w = 0; w < calculationWarnings.length; w++) {
          warningsPart.push({title: (w + 1).toString() + ')', value: calculationWarnings[w]});
        }
        let calcWarningsPart = createWarningsTable(warningsPart);

        let warningsTitle = [];
        if (printProjects) {
          warningsTitle.push({text: '', pageBreak: 'after'});
        }
        warningsTitle.push(createPartTitle(ui['PDF-WARNINGS']));

        calculationsPrintOut.push(objectTitle, columnObjectInfo, resultsTitle, calcResultsPart, warningsTitle, calcWarningsPart);
      } else {
        calculationsPrintOut.push(objectTitle, columnObjectInfo, resultsTitle, calcResultsPart);
      }
    }

    if(i < calculationsEndIndex - 1) {
      calculationsPrintOut.push({text: '', pageBreak: 'after'});
    }
  }

  let headerText = '';
  if(printDate) {
    // headerText += printDateValue.toString();
    headerText += printDateValue.replace(/[^1234567890.\/ ]/g, '');
  }
  if(printTime) {
    if(headerText != '') headerText += ', ';
    headerText += printTimeValue.replace(/[^1234567890: ]/g, '');
    // headerText += printTimeValue.toString();
  }
  if(printName) {
    if(headerText != '') headerText += ', ';
    headerText += printNameValue.toString();
  }
//  console.log(JSON.stringify(calculationsPrintOut));

  let dbDate = databasedate.data[0].updated;
  var pdfFrame =
    {

      pageSize: 'A4',
      pageMargins: [30, 30, 30, 50],

      info: {
          title: 'Paroc Calculus',
          author: 'Paroc',
      },

      header: function(currentPage, pageCount) {
        return {
          table: {
          widths: [ '*', '*' ],
          body: [
            [ { text: headerText, alignment: 'left', style: 'header' }, {text: currentPage + '/' + pageCount, alignment: 'right', bold: true, style: 'header' } ]
          ]
          }, layout: 'noBorders'
        };
      },

      footer: function(currentPage, pageCount) {
        if(currentPage == 1) {
          return [
            {table: {
                widths: ['100%'],
                body: [
                  [{text: '', lineHeight: 0, fontSize: 0}]
                ]
              },
              layout: {
                hLineWidth: function(i, node) {
                  if(i === 0) {return 1;}
                  return 0;
                },
                hLineColor: function(i, node) {
                  return 'black';
                },
                vLineWidth: function(i, node) {return 0;}
              }, marginBottom: 0, marginLeft: 30, marginRight: 30
            },
            {
              // text: ui['PDF-DISCLAIMER1']+' '+ui['PDF-DISCLAIMER2']+', '+ui['SETTINGS-APPLICATION_VERSION']+': '+app_version+', '+ui['SETTINGS-DATABASE_VERSION']+': '+dbDate, style: 'footer'
              text: ui['PDF-DISCLAIMER1'] + ', ' + ui['SETTINGS-APPLICATION_VERSION'] + ': ' + app_version + ', ' + ui['SETTINGS-DATABASE_VERSION'] + ': ' + dbDate, style: 'footer'
            }];
        }
        return {};
      },

      styles: {
        header: {
          fontSize: 10,
          marginLeft: 30,
          marginRight: 30
        },
        footer: {
          fontSize: 5,
          marginLeft: 30,
          marginRight: 30,
          marginTop: 0,
          lineHeight: 0.95
        },

        mainTitle: {
          fontSize: 26,
          bold: true,
          alignment: 'justify',
          color: parocRed
        },
        mainTitleIngres: {
          fontSize: 9,
          marginBottom: 50
        },

        mainTitleIngresSmall: {
          fontSize: 9,
          marginBottom: 20
        },
        mainMarineIngres: {
          fontSize: 26,
          marginBottom: 20
        },

        partTitle: {
          fontSize: 20
        },

        tableTitle: {
          fontSize: 10,
          bold: true,
          marginBottom: 4
        },

        tableRow: {
          fontSize: 8.5,
          marginTop: 3,
          marginRight: 4,
          marginBottom: 3,
          marginLeft: 4
        },

        adapterNotice: {
          fontSize: 8
        },

      },
      pageBreakBefore: function(currentNode, followingNodesOnPage, nodesOnNextPage, previousNodesOnPage) {
        return (currentNode.startPosition.top > 730);
      }
    };
    if(useMarineProducts) {
      pdfFrame.content = [
        {
          text: 'PAROC Calculus',
          style: 'mainTitle'
        },
        {
          text: ui['APPLICATION-LONG_NAME'],
          style: 'mainTitleIngresSmall'
        },
        {
          text: ui['CALCULATION-USE_MARINE_PRODUCTS'],
          style: 'mainMarineIngres'
        },
        calculationsPrintOut
      ];
    } else {
      pdfFrame.content = [
        {
          text: 'PAROC Calculus',
          style: 'mainTitle'
        },
        {
          text: ui['APPLICATION-LONG_NAME'],
          style: 'mainTitleIngres'
        },
        calculationsPrintOut
      ];
    }

  // In pdfmake@0.3.7, `download()` only reliably accepts the filename; the
  // callback isn't called. The PDF download still works, so we clear the
  // "Generating pdf" overlay immediately after starting the download.
  const pdf = ensurePdfMake().createPdf(pdfFrame);

  if (pdf && typeof pdf.download === 'function') {
    pdf.download('Paroc-Calculus.pdf');
    store.dispatch(pdfCreated());
    return;
  }

  // Fallback for environments where `download()` is missing.
  if (pdf && typeof pdf.getBlob === 'function' && typeof window !== 'undefined') {
    pdf.getBlob()
      .then(blob => {
        try {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'Paroc-Calculus.pdf';
          link.click();
          window.URL.revokeObjectURL(url);
        } finally {
          store.dispatch(pdfCreated());
        }
      })
      .catch(err => {
        console.log(err);
        store.dispatch(pdfCreated());
      });
    return;
  }

  store.dispatch(pdfCreated());
}

function createPartTitle(text) {
  return [
    {text: text, style: 'partTitle'},
    {table: {
        widths: ['100%'],
        body: [
          [{text: '', lineHeight: 0, fontSize: 0}]
        ]
      },
      layout: {
        hLineWidth: function(i, node) {
          if(i === 0) {return 1;}
          return 0;
        },
        hLineColor: function(i, node) {
          return 'black';
        },
        vLineWidth: function(i, node) {return 0;}
      }, marginBottom: 5
    }
  ];
}

function createTableTwoCols(printValues) {
  let title;
  if(printValues.title !== undefined) {
    title = {text: printValues.title, style: 'tableTitle'};
  }

  let items = [];
  for(let i = 0; i < printValues.items.length; i++) {
    let style = dGreen;
    if(i % 2 == 0) {style = lGreen;}
    if(printValues.items[i].warnings) {
      items[i] = [{text: printValues.items[i].title, fillColor: style, style: 'tableRow' }, {text: [ {text: printValues.items[i].warnings, color: '#ff0000'}, {text: printValues.items[i].value}], fillColor: style, alignment: 'right', style: 'tableRow' }];
    } else {
      items[i] = [{text: printValues.items[i].title, fillColor: style, style: 'tableRow' }, {text: printValues.items[i].value, fillColor: style, alignment: 'right', style: 'tableRow' }];
    }
  }


  return (printValues.title !== undefined) ? [
    title,
    {table: {
      widths: [ '68%', '32%' ],
      body:
        items
       }, layout: 'noBorders', marginBottom: 7
    }
  ] : [
    {table: {
      widths: [ '68%', '32%' ],
      body:
        items
       }, layout: 'noBorders', marginBottom: 7
    }
  ];
}

function createTableThreeCols(printValues) {
  let title = printValues.title;
  let items = [];
  for(let i = 0; i < printValues.items.length; i++) {
    let style = dGreen;
    if(i % 2 == 0) {style = lGreen;}
    if(printValues.items[i].warnings) {
      items[i] = [{text: [ {text: printValues.items[i].title, fillColor: style, style: 'tableRow' }, {text: printValues.items[i].warnings, color: '#ff0000'}], fillColor: style, style: 'tableRow'}, {text: printValues.items[i].detail, fillColor: style, alignment: 'right', style: 'tableRow' }, {text: printValues.items[i].value, fillColor: style, alignment: 'right', style: 'tableRow' }];
    } else if(printValues.items[i].detail !== '') {
      items[i] = [{text: printValues.items[i].title, fillColor: style, style: 'tableRow' }, {text: printValues.items[i].detail, fillColor: style, alignment: 'right', style: 'tableRow' }, {text: printValues.items[i].value, fillColor: style, alignment: 'right', style: 'tableRow' }];
    } else {
      items[i] = [{text: printValues.items[i].title, fillColor: style, style: 'tableRow', colSpan: 2}, '', {text: printValues.items[i].value, fillColor: style, alignment: 'right', style: 'tableRow' }];
    }
  }
  return [
    {text: printValues.title, style: 'tableTitle'},
    {table: {
      widths: [ '60%', '20%', '20%' ],
      body:
        items
       }, layout: 'noBorders', marginBottom: 7
    }
  ];
}

function createTableFourCols(printValues) {
  let title = printValues.title;
  let items = [];
  for(let i = 0; i < printValues.items.length; i++) {
    let style = dGreen;
    if(i % 2 == 0) {style = lGreen;}
    items[i] = [{text: printValues.items[i].title, fillColor: style, style: 'tableRow' },
              {text: printValues.items[i].insulation, fillColor: style, alignment: 'right', style: 'tableRow'},
              {text: printValues.items[i].count, fillColor: style, alignment: 'right', style: 'tableRow' },
              {text: printValues.items[i].value, fillColor: style, alignment: 'right', style: 'tableRow' }];
  }
  return [
    {text: printValues.title, style: 'tableTitle'},
    {table: {
      widths: [ '40%', '20%', '15%', '25%' ],
      body:
        items
       }, layout: 'noBorders', marginBottom: 7
    }
  ];
}

function createTableFiveCols(printValues) {
  let title = printValues.title;
  let items = [];
  for(let i = 0; i < printValues.items.length; i++) {
    let style = dGreen;
    if(i % 2 == 0) {style = lGreen;}
    items[i] = [{text: printValues.items[i].title, fillColor: style, style: 'tableRow' },
              {text: printValues.items[i].insulation, fillColor: style, alignment: 'right', style: 'tableRow'},
              {text: printValues.items[i].count, fillColor: style, alignment: 'right', style: 'tableRow' },
              {text: printValues.items[i].eq, fillColor: style, alignment: 'right', style: 'tableRow' },
              {text: printValues.items[i].value, fillColor: style, alignment: 'right', style: 'tableRow' }];
  }
  return [
    {text: printValues.title, style: 'tableTitle'},
    {table: {
      widths: [ '20%', '30%', '10%', '25%', '15%' ],
      body:
        items
       }, layout: 'noBorders', marginBottom: 7
    }
  ];
}

function createWarningsTable(printValues) {
  let items = [];
  for(let i = 0; i < printValues.length; i++) {
    let style = dGreen;
    if(i % 2 == 0) {style = lGreen;}
    items[i] = [{text: printValues[i].title, color: '#ff0000', fillColor: style, style: 'tableRow' }, {text: printValues[i].value, fillColor: style,  style: 'tableRow' }];
  }


  return [
    {table: {
      widths: [ '5%', '95%' ],
      body:
        items
       }, layout: 'noBorders', marginBottom: 7
    }
  ];
}

function formatW(value) {
  let retVal = value.toString() + ' W';
  if(value > 9999) {
    retVal = (numeral(value / 1000).format('0.0')).toString() + ' kW';
  } else if(value > 99) {
    retVal = (numeral(value).format('0')).toString() + ' W';
  }
  return retVal;
}

function formatWperArea(value) {
  let retVal = value.toString() + ' W/m²';
  if(value > 9999) {
    retVal = (numeral(value / 1000).format('0.0')).toString() + ' kW/m²';
  } else if(value > 99) {
    retVal = (numeral(value).format('0')).toString() + ' W/m²';
  }
  return retVal;
}

function formatWperLength(value) {
  let retVal = value.toString() + ' W/m';
  if(value > 9999) {
    retVal = (numeral(value / 1000).format('0.0')).toString() + ' kW/m';
  } else if(value > 99) {
    retVal = (numeral(value).format('0')).toString() + ' W/m';
  }
  return retVal;
}
